var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5Mental(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 227,
    height: 274.041,
    viewBox: "0 0 227 274.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25426",
    "data-name": "Rectangle 25426",
    width: 215.529,
    height: 192.153,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25371",
    "data-name": "Rectangle 25371",
    width: 3.651,
    height: 3.163,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25373",
    "data-name": "Rectangle 25373",
    width: 1.826,
    height: 4.217,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25374",
    "data-name": "Rectangle 25374",
    width: 26.423,
    height: 18.61,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25376",
    "data-name": "Rectangle 25376",
    width: 1.827,
    height: 4.416,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25377",
    "data-name": "Rectangle 25377",
    width: 26.424,
    height: 42.659,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25378",
    "data-name": "Rectangle 25378",
    width: 23.77,
    height: 41.135,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25379",
    "data-name": "Rectangle 25379",
    width: 50.194,
    height: 28.973,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25380",
    "data-name": "Rectangle 25380",
    width: 20.119,
    height: 26.376,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25381",
    "data-name": "Rectangle 25381",
    width: 20.119,
    height: 19.046,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25382",
    "data-name": "Rectangle 25382",
    width: 12.696,
    height: 14.76,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25383",
    "data-name": "Rectangle 25383",
    width: 20.119,
    height: 17.942,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25384",
    "data-name": "Rectangle 25384",
    width: 11.42,
    height: 6.593,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25385",
    "data-name": "Rectangle 25385",
    width: 7.065,
    height: 10.49,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25386",
    "data-name": "Rectangle 25386",
    width: 6.144,
    height: 10.488,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25387",
    "data-name": "Rectangle 25387",
    width: 7.489,
    height: 10.295,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25388",
    "data-name": "Rectangle 25388",
    width: 108.953,
    height: 93.642,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25389",
    "data-name": "Rectangle 25389",
    width: 30.584,
    height: 28.374,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25390",
    "data-name": "Rectangle 25390",
    width: 107.02,
    height: 83.256,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25391",
    "data-name": "Rectangle 25391",
    width: 49.045,
    height: 49.469,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25392",
    "data-name": "Rectangle 25392",
    width: 7.717,
    height: 7.149,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25393",
    "data-name": "Rectangle 25393",
    width: 9.249,
    height: 4.787,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25396",
    "data-name": "Rectangle 25396",
    width: 9.25,
    height: 4.787,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25401",
    "data-name": "Rectangle 25401",
    width: 7.716,
    height: 7.149,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25402",
    "data-name": "Rectangle 25402",
    width: 91.819,
    height: 77.658,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25403",
    "data-name": "Rectangle 25403",
    width: 15.868,
    height: 15.545,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25404",
    "data-name": "Rectangle 25404",
    width: 10.867,
    height: 19.655,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25405",
    "data-name": "Rectangle 25405",
    width: 49.636,
    height: 52.013,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25406",
    "data-name": "Rectangle 25406",
    width: 22.046,
    height: 28.948,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25407",
    "data-name": "Rectangle 25407",
    width: 16.847,
    height: 26.158,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25408",
    "data-name": "Rectangle 25408",
    width: 3.961,
    height: 1.843,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25409",
    "data-name": "Rectangle 25409",
    width: 25.839,
    height: 34.909,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25410",
    "data-name": "Rectangle 25410",
    width: 9.955,
    height: 4.384,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25411",
    "data-name": "Rectangle 25411",
    width: 12.836,
    height: 7.695,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25412",
    "data-name": "Rectangle 25412",
    width: 1.324,
    height: 1.756,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25413",
    "data-name": "Rectangle 25413",
    width: 15.974,
    height: 20.745,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25414",
    "data-name": "Rectangle 25414",
    width: 3.588,
    height: 14.853,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25415",
    "data-name": "Rectangle 25415",
    width: 3.286,
    height: 1.064,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25416",
    "data-name": "Rectangle 25416",
    width: 0.559,
    height: 0.729,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25419",
    "data-name": "Rectangle 25419",
    width: 0.56,
    height: 0.729,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25423",
    "data-name": "Rectangle 25423",
    width: 11.244,
    height: 34.098,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25424",
    "data-name": "Rectangle 25424",
    width: 4.89,
    height: 1.976,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87917",
    "data-name": "Group 87917",
    transform: "translate(-14181 -19759)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4987",
    "data-name": "Ellipse 4987",
    cx: 113.5,
    cy: 113.5,
    r: 113.5,
    transform: "translate(14181 19759)",
    fill: "#d2e5c7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87818",
    "data-name": "Group 87818",
    transform: "translate(14277 19781.439)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_24009",
    "data-name": "Rectangle 24009",
    width: 33.074,
    height: 42.42,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203106",
    "data-name": "Path 203106",
    d: "M14.7,2.96l.16.1c.27.779.609,2.017.959,3.325v.21l-.889.07Z",
    transform: "translate(-0.021 -0.004)",
    fill: "#ffa900"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87848",
    "data-name": "Group 87848",
    transform: "translate(14186 19840.889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87667",
    "data-name": "Group 87667",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87666",
    "data-name": "Group 87666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87665",
    "data-name": "Group 87665",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275860",
    "data-name": "Path 275860",
    d: "M31.563,158.634c-42.084-23.12-42.084-60.6,0-83.718s110.316-23.12,152.4,0,42.085,60.6,0,83.72-110.318,23.117-152.4,0",
    transform: "translate(0 16.18)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275861",
    "data-name": "Path 275861",
    d: "M113.566,144.822l69.682-40.232c2.119-1.223,2.119-3.205,0-4.428L154.941,83.818a8.475,8.475,0,0,0-7.671,0L77.587,124.05c-2.118,1.222-2.118,3.205,0,4.428L105.9,144.822a8.475,8.475,0,0,0,7.671,0",
    transform: "translate(21.357 23.297)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275862",
    "data-name": "Path 275862",
    d: "M95.857,133.064,74.2,118.5l14.268-8.24c2.119-1.222,2.119-3.205,0-4.427L60.156,89.493a8.483,8.483,0,0,0-7.671,0l-40.9,23.614c-2.119,1.223-2.119,3.205,0,4.428l28.308,16.343a8.472,8.472,0,0,0,7.669,0l7.908-4.566,25.362,13.1c4.346,2.246,11.091,2.206,15.065-.088s3.956-6.441-.041-9.262",
    transform: "translate(2.81 24.892)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275863",
    "data-name": "Path 275863",
    d: "M105.442,93.9,78.5,78.349a4.228,4.228,0,0,0-3.833.005L52.276,91.349a1.171,1.171,0,0,0,0,2.217l26.944,15.549a4.228,4.228,0,0,0,3.833-.005l22.39-12.993a1.172,1.172,0,0,0,0-2.219",
    transform: "translate(14.468 21.889)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275864",
    "data-name": "Path 275864",
    d: "M15.158,25.025l.76.439,19-10.971-.76-.439Z",
    transform: "translate(4.26 3.949)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275865",
    "data-name": "Path 275865",
    d: "M33.992,17.523,15.752,28.054V12.244L33.992,1.712Z",
    transform: "translate(4.427 0.481)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275866",
    "data-name": "Path 275866",
    d: "M35.679.342,15.158,12.19V30.633L35.68,18.785Zm-.76,18-19,10.971V12.63l19-10.971Z",
    transform: "translate(4.26 0.096)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275867",
    "data-name": "Path 275867",
    d: "M30.75,18.058l-.76-.439V1.809l.76-.439Z",
    transform: "translate(8.428 0.385)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275868",
    "data-name": "Path 275868",
    d: "M35.846.439,35.086,0,14.564,11.848l.761.439Z",
    transform: "translate(4.093 0)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275869",
    "data-name": "Path 275869",
    d: "M14.565,9.249l.76.439V28.131l-.76-.439Z",
    transform: "translate(4.093 2.599)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275870",
    "data-name": "Path 275870",
    d: "M27.479,12.018c.708-.409,1.282-.077,1.282.74a2.835,2.835,0,0,1-1.282,2.223c-.708.409-1.282.077-1.282-.74a2.835,2.835,0,0,1,1.282-2.223",
    transform: "translate(7.362 3.328)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275871",
    "data-name": "Path 275871",
    d: "M19.212,10.611,28.871,5.03c.269-.155.487-.029.487.281v.028a1.077,1.077,0,0,1-.487.843l-9.659,5.585c-.269.156-.487.031-.487-.281v-.032a1.075,1.075,0,0,1,.487-.843",
    transform: "translate(5.262 1.395)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275872",
    "data-name": "Path 275872",
    d: "M18.02,14.431l12.714-7.34c.268-.155.486-.085.486.158a.973.973,0,0,1-.486.72L18.011,15.314c-.269.155-.484.083-.482-.16a.988.988,0,0,1,.491-.722",
    transform: "translate(4.926 1.97)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275873",
    "data-name": "Path 275873",
    d: "M18.02,15.8,30.734,8.46c.268-.155.486-.085.486.158a.973.973,0,0,1-.486.72L18.011,16.683c-.269.155-.484.083-.482-.16a.988.988,0,0,1,.491-.722",
    transform: "translate(4.926 2.354)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275874",
    "data-name": "Path 275874",
    d: "M18.02,17.169l12.714-7.34c.268-.155.486-.085.486.158a.973.973,0,0,1-.486.72L18.011,18.052c-.269.155-.484.083-.482-.16a.988.988,0,0,1,.491-.722",
    transform: "translate(4.926 2.739)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275875",
    "data-name": "Path 275875",
    d: "M27.4,15.027a.707.707,0,0,1-.318.083c-.272,0-.246-.277-.238-.468,0-.086-.117-.218-.179-.105-.164.3-.373.573-.551.863-.108.177-.314.576-.575.52-.109-.024-.145-.141-.145-.286a1.43,1.43,0,0,0,.17-.793c-.009-.083-.15-.184-.193-.072a2.547,2.547,0,0,0-.165.729,4.472,4.472,0,0,1-.41.612c-.088.117-.167.247-.264.359-.023.026-.068.092-.106.1-.09.015-.081-.038-.092-.1a.642.642,0,0,1,.044-.261h0l.006-.02-.005,0c0-.087-.109-.214-.155-.106a3.859,3.859,0,0,1-.746,1.243c-.017.015-.033.028-.05.041,0-.05-.014-.1-.018-.152a1.38,1.38,0,0,0-.06-.346c-.022-.055-.119-.141-.17-.067a5.944,5.944,0,0,1-.845,1.17,1.406,1.406,0,0,1-.178.124c-.058-.033.032-.341.044-.388.035-.138.081-.273.126-.409a1.486,1.486,0,0,0,.1-.337c.018-.1-.163-.265-.2-.124-.013.058-.063.2-.117.369a9.065,9.065,0,0,1-.714,1.208,2.788,2.788,0,0,1-.993.957c-.114.06-.324.149-.448.06-.1-.074-.111-.246-.117-.36a3.1,3.1,0,0,1,.119-.88,5.33,5.33,0,0,0,1.1-.778,3.785,3.785,0,0,0,.833-.924c.114-.2.181-.539-.094-.656-.188-.079-.433.053-.594.142a2.633,2.633,0,0,0-.6.471,3.475,3.475,0,0,0-.758,1.386c-.024.079-.055.183-.087.3a2.347,2.347,0,0,1-1.4.234c-.026,0-.037.055-.012.06a2.3,2.3,0,0,0,1.371-.131c-.123.532-.192,1.235.3,1.372.528.145,1.093-.483,1.358-.839a5.687,5.687,0,0,0,.532-.858.439.439,0,0,1,.046-.063c-.015.246.049.425.29.386s.468-.389.6-.576.243-.364.361-.547c.022.222.061.474.274.432s.387-.411.487-.561a4.508,4.508,0,0,0,.241-.4.285.285,0,0,0,.047.073c.177.19.386-.013.5-.163.161-.213.343-.437.5-.676a.407.407,0,0,0,.21.237c.272.128.526-.1.684-.3A5.853,5.853,0,0,0,26.666,15a.379.379,0,0,0,.187.26.624.624,0,0,0,.639-.041c.083-.051,0-.233-.087-.188m-5.949,1.062c.127-.064.389-.172.4.041a.716.716,0,0,1-.173.371,4.62,4.62,0,0,1-.739.787,5.913,5.913,0,0,1-.926.7,2.987,2.987,0,0,1,1.435-1.9",
    transform: "translate(5.154 4.073)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275876",
    "data-name": "Path 275876",
    d: "M38.538,25.025l.76.439,19-10.971-.76-.439Z",
    transform: "translate(10.83 3.949)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275877",
    "data-name": "Path 275877",
    d: "M57.372,17.523,39.132,28.054V12.244L57.372,1.712Z",
    transform: "translate(10.997 0.481)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275878",
    "data-name": "Path 275878",
    d: "M59.059.342,38.538,12.19V30.633L59.06,18.785Zm-.76,18-19,10.971V12.63l19-10.971Z",
    transform: "translate(10.83 0.096)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275879",
    "data-name": "Path 275879",
    d: "M54.13,18.058l-.76-.439V1.809l.76-.439Z",
    transform: "translate(14.998 0.385)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275880",
    "data-name": "Path 275880",
    d: "M59.226.439,58.466,0,37.944,11.848l.761.439Z",
    transform: "translate(10.663 0)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275881",
    "data-name": "Path 275881",
    d: "M37.945,9.249l.76.439V28.131l-.76-.439Z",
    transform: "translate(10.663 2.599)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275882",
    "data-name": "Path 275882",
    d: "M50.859,12.018c.708-.409,1.282-.077,1.282.74a2.835,2.835,0,0,1-1.282,2.223c-.708.409-1.282.077-1.282-.74a2.835,2.835,0,0,1,1.282-2.223",
    transform: "translate(13.932 3.328)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275883",
    "data-name": "Path 275883",
    d: "M42.592,10.611,52.251,5.03c.269-.155.487-.029.487.281v.028a1.077,1.077,0,0,1-.487.843l-9.659,5.585c-.269.156-.487.031-.487-.281v-.032a1.075,1.075,0,0,1,.487-.843",
    transform: "translate(11.832 1.395)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275884",
    "data-name": "Path 275884",
    d: "M41.4,14.431l12.713-7.34c.268-.155.486-.085.486.158a.973.973,0,0,1-.486.72L41.39,15.314c-.269.155-.484.083-.482-.16a.987.987,0,0,1,.492-.722",
    transform: "translate(11.496 1.97)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275885",
    "data-name": "Path 275885",
    d: "M41.4,15.8,54.113,8.46c.268-.155.486-.085.486.158a.973.973,0,0,1-.486.72L41.39,16.683c-.269.155-.484.083-.482-.16A.987.987,0,0,1,41.4,15.8",
    transform: "translate(11.496 2.354)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275886",
    "data-name": "Path 275886",
    d: "M41.4,17.169l12.713-7.34c.268-.155.486-.085.486.158a.973.973,0,0,1-.486.72L41.39,18.052c-.269.155-.484.083-.482-.16a.987.987,0,0,1,.492-.722",
    transform: "translate(11.496 2.739)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275887",
    "data-name": "Path 275887",
    d: "M50.785,15.027a.707.707,0,0,1-.318.083c-.272,0-.246-.277-.238-.468,0-.086-.117-.218-.179-.105-.164.3-.373.573-.551.863-.108.177-.314.576-.575.52-.109-.024-.145-.141-.145-.286a1.43,1.43,0,0,0,.17-.793c-.009-.083-.15-.184-.193-.072a2.547,2.547,0,0,0-.165.729,4.472,4.472,0,0,1-.41.612c-.088.117-.167.247-.264.359-.023.026-.068.092-.106.1-.09.015-.081-.038-.092-.1a.642.642,0,0,1,.044-.261h0l.006-.02-.005,0c0-.087-.109-.214-.155-.106a3.859,3.859,0,0,1-.746,1.243c-.017.015-.033.028-.05.041,0-.05-.014-.1-.018-.152a1.379,1.379,0,0,0-.06-.346c-.022-.055-.119-.141-.17-.067a5.943,5.943,0,0,1-.845,1.17,1.406,1.406,0,0,1-.178.124c-.058-.033.032-.341.044-.388.035-.138.081-.273.126-.409a1.486,1.486,0,0,0,.1-.337c.018-.1-.163-.265-.2-.124-.013.058-.063.2-.117.369a9.065,9.065,0,0,1-.714,1.208,2.788,2.788,0,0,1-.993.957c-.114.06-.324.149-.448.06-.1-.074-.111-.246-.117-.36a3.1,3.1,0,0,1,.119-.88,5.33,5.33,0,0,0,1.1-.778,3.785,3.785,0,0,0,.833-.924c.114-.2.181-.539-.094-.656-.188-.079-.434.053-.594.142a2.633,2.633,0,0,0-.6.471,3.475,3.475,0,0,0-.758,1.386c-.024.079-.055.183-.087.3a2.347,2.347,0,0,1-1.4.234c-.026,0-.037.055-.012.06A2.3,2.3,0,0,0,43.1,18.3c-.123.532-.192,1.235.3,1.372.528.145,1.093-.483,1.358-.839a5.688,5.688,0,0,0,.532-.858.439.439,0,0,1,.046-.063c-.015.246.049.425.29.386s.468-.389.6-.576.243-.364.361-.547c.022.222.061.474.274.432s.387-.411.487-.561a4.509,4.509,0,0,0,.241-.4.285.285,0,0,0,.047.073c.177.19.386-.013.5-.163.161-.213.343-.437.5-.676a.407.407,0,0,0,.21.237c.272.128.527-.1.684-.3A5.853,5.853,0,0,0,50.046,15a.379.379,0,0,0,.187.26.624.624,0,0,0,.639-.041c.083-.051,0-.233-.087-.188m-5.949,1.062c.127-.064.389-.172.4.041a.716.716,0,0,1-.173.371,4.62,4.62,0,0,1-.739.787,5.913,5.913,0,0,1-.926.7,2.987,2.987,0,0,1,1.435-1.9",
    transform: "translate(11.724 4.073)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275888",
    "data-name": "Path 275888",
    d: "M122.442,11.89V10.031h0a.632.632,0,0,1,.372-.5l11.233-6.446a1.916,1.916,0,0,1,1.727,0L168.067,21.62a.638.638,0,0,1,.373.5h0v1.859h0a.637.637,0,0,1-.373.5l-11.233,6.446a1.916,1.916,0,0,1-1.727,0L122.815,12.385a.634.634,0,0,1-.372-.5Z",
    transform: "translate(34.409 0.81)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275889",
    "data-name": "Path 275889",
    d: "M168.063,22.612,156.83,29.058a1.916,1.916,0,0,1-1.727,0L122.811,10.527a.523.523,0,0,1,0-.992l11.233-6.446a1.916,1.916,0,0,1,1.727,0L168.063,21.62a.523.523,0,0,1,0,.992",
    transform: "translate(34.412 0.81)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275890",
    "data-name": "Path 275890",
    d: "M148.616,25.091V26.95a1.778,1.778,0,0,0,.861-.206L160.711,20.3a.632.632,0,0,0,.372-.5h0V17.944h0a.465.465,0,0,0-.07-.211c.129.24.032.515-.3.706l-11.235,6.446a1.74,1.74,0,0,1-.861.206",
    transform: "translate(41.764 4.983)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275891",
    "data-name": "Path 275891",
    d: "M149.442,13.183l-9.517,5.425L124.2,9.586l9.517-5.426Z",
    transform: "translate(34.903 1.169)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275892",
    "data-name": "Path 275892",
    d: "M136.394,16.795l9.181-5.269a3.8,3.8,0,0,1,.049-2.38L136.5,14.358a8.987,8.987,0,0,0-.109,2.437",
    transform: "translate(38.325 2.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275893",
    "data-name": "Path 275893",
    d: "M137.036,13.773a1.937,1.937,0,0,0-.883,1.519v1.773c0,.56.4.787.883.507l9.048-5.193V11.94l-8.927,5.091c-.292.168-.529.032-.529-.3l.009-1.645a1.163,1.163,0,0,1,.529-.911l8.917-5.093v-.5Z",
    transform: "translate(38.262 2.411)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275894",
    "data-name": "Path 275894",
    d: "M149.532,10.562,133.81,1.538,124.762,6.73a1.938,1.938,0,0,0-.881,1.519v1.774a.616.616,0,0,0,.257.567l15.723,9.022a.614.614,0,0,1-.259-.566V17.271a1.936,1.936,0,0,1,.881-1.519Z",
    transform: "translate(34.813 0.432)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275895",
    "data-name": "Path 275895",
    d: "M139.859,15.124a1.78,1.78,0,0,0-.259.863v1.775a.618.618,0,0,0,.259.567L124.139,9.308a.616.616,0,0,1-.259-.567V6.967a1.784,1.784,0,0,1,.259-.865Z",
    transform: "translate(34.813 1.715)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275896",
    "data-name": "Path 275896",
    d: "M153.823.663l.088,1.2-10.625,5.7-.24-.7Z",
    transform: "translate(40.199 0.186)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275897",
    "data-name": "Path 275897",
    d: "M143.157,7.025l10.292-5.941,1.791,1.034-10.5,6.14Z",
    transform: "translate(40.23 0.304)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275898",
    "data-name": "Path 275898",
    d: "M147.143,6.186l1.017,11.926a.842.842,0,0,1-.38.661l-5.971,3.456a.742.742,0,0,1-.309.088l3.71-15.107a.753.753,0,0,0,.31-.087l.43-.25Z",
    transform: "translate(39.764 1.738)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275899",
    "data-name": "Path 275899",
    d: "M145.286,7.337l-1.065-.912-.781-.67c-.079-.127-.173-.222-.123-.327l-3.661,15-.005.013c-.053.105-.065.341.078.423l1.846,1.581a.815.815,0,0,0,.455.088l3.71-15.107a.819.819,0,0,1-.453-.087",
    transform: "translate(39.235 1.525)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275900",
    "data-name": "Path 275900",
    d: "M142.632,6.719c-.211.122-.159.257,0,.441l1.846,1.581a.844.844,0,0,0,.763,0l1.623-.936c.211-.122.249-.3.083-.393a.763.763,0,0,0-.679.049l-1.281.739a.28.28,0,0,1-.255,0l-1.349-1.171a.078.078,0,0,1,0-.147l10.6-6.153-.507-.293Z",
    transform: "translate(40.043 0.122)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275901",
    "data-name": "Path 275901",
    d: "M156.074,1.113,145.95,6.962v19.26l10.124-5.848Z",
    transform: "translate(41.015 0.313)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275902",
    "data-name": "Path 275902",
    d: "M146.2,7.162,156,1.538a4.116,4.116,0,0,0,2.241,1.226l-9.715,5.6a9.767,9.767,0,0,1-2.324-1.2",
    transform: "translate(41.086 0.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275903",
    "data-name": "Path 275903",
    d: "M149.614,8.5a2.092,2.092,0,0,1-1.883,0l-1.65-.947a.57.57,0,0,1,0-1.081L155.738.93l.409.233-9.5,5.485a.341.341,0,0,0,0,.648l1.533.87a1.258,1.258,0,0,0,1.13,0l9.495-5.475.462.266Z",
    transform: "translate(40.942 0.261)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275904",
    "data-name": "Path 275904",
    d: "M159.27,2.513V21.774l-9.656,5.542a2.1,2.1,0,0,1-1.883,0l-1.65-.947a.66.66,0,0,1-.389-.541V6.567a.658.658,0,0,0,.389.541l1.65.948a2.092,2.092,0,0,0,1.883,0Z",
    transform: "translate(40.942 0.706)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275905",
    "data-name": "Path 275905",
    d: "M148.672,7.391a1.927,1.927,0,0,1-.942-.224l-1.65-.948a.66.66,0,0,1-.389-.541V24.939a.657.657,0,0,0,.389.539l1.65.947a1.927,1.927,0,0,0,.942.224Z",
    transform: "translate(40.942 1.596)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275906",
    "data-name": "Path 275906",
    d: "M90.316,93.316l-3.651-2.109,3.651-1.054Z",
    transform: "translate(24.355 25.335)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87505",
    "data-name": "Group 87505",
    transform: "translate(111.019 115.488)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87504",
    "data-name": "Group 87504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87503",
    "data-name": "Group 87503",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275907",
    "data-name": "Path 275907",
    d: "M90.316,93.316l-3.651-2.109,3.651-1.054Z",
    transform: "translate(-86.665 -90.153)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87508",
    "data-name": "Group 87508",
    transform: "translate(111.019 115.488)",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87507",
    "data-name": "Group 87507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87506",
    "data-name": "Group 87506",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275908",
    "data-name": "Path 275908",
    d: "M90.316,93.316l-3.651-2.109,3.651-1.054Z",
    transform: "translate(-86.665 -90.153)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275909",
    "data-name": "Path 275909",
    d: "M89.515,93.547l1.827-1.054V89.33l-1.827,1.054Z",
    transform: "translate(25.155 25.104)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87511",
    "data-name": "Group 87511",
    transform: "translate(114.67 114.434)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87510",
    "data-name": "Group 87510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87509",
    "data-name": "Group 87509",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275910",
    "data-name": "Path 275910",
    d: "M89.515,93.547l1.827-1.054V89.33l-1.827,1.054Z",
    transform: "translate(-89.515 -89.331)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275911",
    "data-name": "Path 275911",
    d: "M81.032,101.743V105.1L54.609,89.857V86.5Z",
    transform: "translate(15.346 24.307)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87514",
    "data-name": "Group 87514",
    transform: "translate(69.955 110.802)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87513",
    "data-name": "Group 87513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87512",
    "data-name": "Group 87512",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275912",
    "data-name": "Path 275912",
    d: "M81.032,101.743V105.1L54.609,89.857V86.5Z",
    transform: "translate(-54.609 -86.495)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87517",
    "data-name": "Group 87517",
    transform: "translate(69.955 110.802)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87516",
    "data-name": "Group 87516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87515",
    "data-name": "Group 87515",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275913",
    "data-name": "Path 275913",
    d: "M81.032,101.743V105.1L54.609,89.857V86.5Z",
    transform: "translate(-54.609 -86.495)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275914",
    "data-name": "Path 275914",
    d: "M75.236,101.991l1.827-1.054V97.576L75.236,98.63Z",
    transform: "translate(21.143 27.421)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87520",
    "data-name": "Group 87520",
    transform: "translate(96.378 124.996)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87519",
    "data-name": "Group 87519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87518",
    "data-name": "Group 87518",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275915",
    "data-name": "Path 275915",
    d: "M75.236,101.991l1.827-1.054V97.576L75.236,98.63Z",
    transform: "translate(-75.236 -97.575)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275916",
    "data-name": "Path 275916",
    d: "M53.183,65.921,79.607,81.169V108.58L53.183,93.331Z",
    transform: "translate(14.946 18.525)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87523",
    "data-name": "Group 87523",
    transform: "translate(68.129 84.446)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87522",
    "data-name": "Group 87522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87521",
    "data-name": "Group 87521",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275917",
    "data-name": "Path 275917",
    d: "M53.183,65.921,79.607,81.169V108.58L53.183,93.331Z",
    transform: "translate(-53.183 -65.921)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275918",
    "data-name": "Path 275918",
    d: "M73.81,80.835,97.581,67.11V94.521L73.81,108.245Z",
    transform: "translate(20.742 18.859)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87526",
    "data-name": "Group 87526",
    transform: "translate(94.553 85.97)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87525",
    "data-name": "Group 87525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87524",
    "data-name": "Group 87524",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275919",
    "data-name": "Path 275919",
    d: "M73.81,80.835,97.581,67.11V94.521L73.81,108.245Z",
    transform: "translate(-73.81 -67.11)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275920",
    "data-name": "Path 275920",
    d: "M103.377,70.455,76.954,55.207,53.183,68.932,79.607,84.18Z",
    transform: "translate(14.946 15.514)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87529",
    "data-name": "Group 87529",
    transform: "translate(68.129 70.721)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87528",
    "data-name": "Group 87528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87527",
    "data-name": "Group 87527",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275921",
    "data-name": "Path 275921",
    d: "M103.377,70.455,76.954,55.207,53.183,68.932,79.607,84.18Z",
    transform: "translate(-53.183 -55.207)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275922",
    "data-name": "Path 275922",
    d: "M75.236,87.779,95.354,76.163v14.76L75.236,102.539Z",
    transform: "translate(21.143 21.403)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87532",
    "data-name": "Group 87532",
    transform: "translate(96.378 97.566)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87531",
    "data-name": "Group 87531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87530",
    "data-name": "Group 87530",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275923",
    "data-name": "Path 275923",
    d: "M75.236,87.779,95.354,76.163v14.76L75.236,102.539Z",
    transform: "translate(-75.236 -76.163)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87535",
    "data-name": "Group 87535",
    transform: "translate(96.378 104.896)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87534",
    "data-name": "Group 87534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87533",
    "data-name": "Group 87533",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275924",
    "data-name": "Path 275924",
    d: "M95.354,89.315,82.66,81.885l-7.424,4.286v14.76Z",
    transform: "translate(-75.235 -81.885)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87538",
    "data-name": "Group 87538",
    transform: "translate(103.802 97.566)",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87537",
    "data-name": "Group 87537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87536",
    "data-name": "Group 87536",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275925",
    "data-name": "Path 275925",
    d: "M93.726,90.923l-12.695-7.43,12.695-7.33Z",
    transform: "translate(-81.03 -76.163)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275926",
    "data-name": "Path 275926",
    d: "M75.236,81.2,95.354,69.579V75.9L75.236,87.521Z",
    transform: "translate(21.143 19.553)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87541",
    "data-name": "Group 87541",
    transform: "translate(96.378 89.132)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87540",
    "data-name": "Group 87540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87539",
    "data-name": "Group 87539",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275927",
    "data-name": "Path 275927",
    d: "M75.236,81.2,95.354,69.579V75.9L75.236,87.521Z",
    transform: "translate(-75.236 -69.579)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275928",
    "data-name": "Path 275928",
    d: "M80.1,77.918c0,.291.871.024,1.946-.6l3.411-1.969c1.075-.62,1.947-1.359,1.947-1.651v-.526L80.1,77.39v.528",
    transform: "translate(22.511 20.563)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87544",
    "data-name": "Group 87544",
    transform: "translate(86.573 80.082)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87543",
    "data-name": "Group 87543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87542",
    "data-name": "Group 87542",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275929",
    "data-name": "Path 275929",
    d: "M77.329,63.48c2.23,1.287,2.23,3.374,0,4.663a8.929,8.929,0,0,1-8.076,0c-2.23-1.289-2.23-3.375,0-4.663a8.925,8.925,0,0,1,8.076,0",
    transform: "translate(-67.582 -62.514)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275930",
    "data-name": "Path 275930",
    d: "M76.5,66.962c1.8-1.837,2.859-6.426,1.1-7.883H68.661c-1.756,1.457-.7,6.044,1.1,7.882l.049.05c.02.02.041.042.063.061.05.049.1.1.163.145l.042.035c.045.035.088.069.136.1.077.054.155.105.233.15a5.927,5.927,0,0,0,5.365,0,2.593,2.593,0,0,0,.234-.151c.045-.029.085-.061.127-.095l.053-.041c.056-.046.108-.094.158-.14l.072-.07.041-.044",
    transform: "translate(19.042 16.602)",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275931",
    "data-name": "Path 275931",
    d: "M69.406,58.815c-2.039,1.177-2.039,3.086,0,4.263a8.163,8.163,0,0,0,7.385,0c2.038-1.177,2.038-3.086,0-4.263a8.163,8.163,0,0,0-7.385,0",
    transform: "translate(19.075 16.28)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275932",
    "data-name": "Path 275932",
    d: "M70.4,59.391a1.369,1.369,0,0,0,0,2.594,4.966,4.966,0,0,0,4.493,0,1.369,1.369,0,0,0,0-2.594,4.966,4.966,0,0,0-4.493,0",
    transform: "translate(19.523 16.539)",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275933",
    "data-name": "Path 275933",
    d: "M74.855,60.352a4.966,4.966,0,0,0-4.493,0,2.051,2.051,0,0,0-.743.682,2.062,2.062,0,0,0,.743.682,4.966,4.966,0,0,0,4.493,0,2.062,2.062,0,0,0,.743-.682,2.051,2.051,0,0,0-.743-.682",
    transform: "translate(19.564 16.809)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275934",
    "data-name": "Path 275934",
    d: "M72.3,63.325a5.917,5.917,0,0,0,5.228-3.09c1.909-3.479-.38-7.4-.38-7.4a5.734,5.734,0,0,1-2.338,1.578,5.108,5.108,0,0,0-3.525,4.24A6.7,6.7,0,0,0,72.3,63.325",
    transform: "translate(20.015 14.848)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87547",
    "data-name": "Group 87547",
    transform: "translate(91.236 67.686)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87546",
    "data-name": "Group 87546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87545",
    "data-name": "Group 87545",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275935",
    "data-name": "Path 275935",
    d: "M72.3,63.325a5.917,5.917,0,0,0,5.228-3.09c1.909-3.479-.38-7.4-.38-7.4a5.734,5.734,0,0,1-2.338,1.578,5.108,5.108,0,0,0-3.525,4.24A6.7,6.7,0,0,0,72.3,63.325",
    transform: "translate(-71.221 -52.837)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87550",
    "data-name": "Group 87550",
    transform: "translate(91.236 67.686)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87549",
    "data-name": "Group 87549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87548",
    "data-name": "Group 87548",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275936",
    "data-name": "Path 275936",
    d: "M77.146,52.837a5.746,5.746,0,0,1-2.338,1.578,5.106,5.106,0,0,0-3.525,4.24A6.7,6.7,0,0,0,72.3,63.325c5.626-4.1,5.284-8.434,4.847-10.488",
    transform: "translate(-71.221 -52.837)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275937",
    "data-name": "Path 275937",
    d: "M76.891,53.761a8.86,8.86,0,0,1-4.116,8.594,11.208,11.208,0,0,0,4.116-8.594",
    transform: "translate(20.451 15.108)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275938",
    "data-name": "Path 275938",
    d: "M74.257,55.142c.851.657,2,2.233,1.154,3.212a6.378,6.378,0,0,0-1.154-3.212",
    transform: "translate(20.868 15.496)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275939",
    "data-name": "Path 275939",
    d: "M73.321,63.283s-3.657-.266-5.05-2.791c-1.467-2.657.343-4.918-.69-7.5,0,0,4.791.514,6.487,3.151,1.945,3.027.708,5.4-.747,7.144",
    transform: "translate(18.992 14.89)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87553",
    "data-name": "Group 87553",
    transform: "translate(86.573 67.878)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87552",
    "data-name": "Group 87552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87551",
    "data-name": "Group 87551",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275940",
    "data-name": "Path 275940",
    d: "M74.068,56.138c-1.7-2.638-6.486-3.151-6.486-3.151,1.193.478,5.9,5.465,5.739,10.3,1.457-1.746,2.693-4.117.747-7.144",
    transform: "translate(-67.581 -52.988)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275941",
    "data-name": "Path 275941",
    d: "M68.079,53.312c2.875,2.217,5.122,5.845,5.1,9.549a16.931,16.931,0,0,0-5.1-9.549",
    transform: "translate(19.132 14.982)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275942",
    "data-name": "Path 275942",
    d: "M68.816,56.869c.954-.1,2.542-.288,3.017.717-1.094-.25-1.924-.561-3.017-.717",
    transform: "translate(19.339 15.958)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275943",
    "data-name": "Path 275943",
    d: "M105.408,125.67h-5.046l.807,4.922h.008a.906.906,0,0,0,.488.607,2.7,2.7,0,0,0,2.44,0,.908.908,0,0,0,.489-.607h.008Z",
    transform: "translate(28.204 35.316)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275944",
    "data-name": "Path 275944",
    d: "M84.908,113.508H79.862l.807,4.922h.008a.906.906,0,0,0,.488.607,2.7,2.7,0,0,0,2.44,0,.908.908,0,0,0,.489-.607H84.1Z",
    transform: "translate(22.443 31.898)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275945",
    "data-name": "Path 275945",
    d: "M158.2,95.181h-5.046l.807,4.922h.008a.906.906,0,0,0,.488.607,2.7,2.7,0,0,0,2.44,0,.908.908,0,0,0,.489-.607h.008Z",
    transform: "translate(43.041 26.748)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275946",
    "data-name": "Path 275946",
    d: "M137.706,83.02H132.66l.807,4.922h.008a.905.905,0,0,0,.488.607,2.7,2.7,0,0,0,2.44,0,.908.908,0,0,0,.489-.607h.008Z",
    transform: "translate(37.28 23.33)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275947",
    "data-name": "Path 275947",
    d: "M149.269,70.968l-.9.519L140.481,84.91a9.75,9.75,0,0,1-3.025,3.024l-57.327,33.1a1.359,1.359,0,0,0-.794,1.085c-.01.407.009,2.877,0,3.273a1.336,1.336,0,0,0,.792,1.122l26.746,15.443a4.257,4.257,0,0,0,3.835,0l67.9-39.24a4.245,4.245,0,0,0,1.918-3.323v-9.2a4.244,4.244,0,0,0-1.918-3.322l-26.53-15.316c-1.059-.611-2.32-.875-2.817-.588",
    transform: "translate(22.294 19.911)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275948",
    "data-name": "Path 275948",
    d: "M177.74,90.684l-6.677,11.564a9.754,9.754,0,0,1-3.024,3.026l-57.328,33.1a4.241,4.241,0,0,1-3.835,0L80.129,122.929a1.168,1.168,0,0,1,0-2.214l57.328-33.1a9.764,9.764,0,0,0,3.024-3.024l6.765-11.513a2.236,2.236,0,0,1,3.04-.8L176.93,87.66a2.214,2.214,0,0,1,.811,3.024",
    transform: "translate(22.295 20.228)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275949",
    "data-name": "Path 275949",
    d: "M108.794,127.9v3.264a3.9,3.9,0,0,1-1.918-.461L80.128,115.265a1.337,1.337,0,0,1-.788-1.125c0-.386-.014-2.781-.005-3.251A1.34,1.34,0,0,0,80.128,112l26.749,15.441a3.918,3.918,0,0,0,1.918.461",
    transform: "translate(22.294 31.162)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275950",
    "data-name": "Path 275950",
    d: "M78.458,118.094v5.958a4.237,4.237,0,0,0,1.918,3.32l26.746,15.443a4.241,4.241,0,0,0,3.835,0L166.6,110.687a10.058,10.058,0,0,0,3.053-3.009L186.278,79.8a9.475,9.475,0,0,0,1.134-4.116v-7a4.239,4.239,0,0,0-1.918-3.322L158.747,49.928a2.214,2.214,0,0,0-3.024.81l-7.064,14.274L139.048,79.62a14,14,0,0,1-2.015,2.443L81.384,114.191c-2.068,1.193-2.926,2.68-2.926,3.9",
    transform: "translate(22.048 13.947)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87556",
    "data-name": "Group 87556",
    transform: "translate(100.506 63.578)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87555",
    "data-name": "Group 87555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87554",
    "data-name": "Group 87554",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275951",
    "data-name": "Path 275951",
    d: "M78.458,118.094v5.958a4.237,4.237,0,0,0,1.918,3.32l26.746,15.443a4.241,4.241,0,0,0,3.835,0L166.6,110.687a10.058,10.058,0,0,0,3.053-3.009L186.278,79.8a9.475,9.475,0,0,0,1.134-4.116v-7a4.239,4.239,0,0,0-1.918-3.322L158.747,49.928a2.214,2.214,0,0,0-3.024.81l-7.064,14.274L139.048,79.62a14,14,0,0,1-2.015,2.443L81.384,114.191c-2.068,1.193-2.926,2.68-2.926,3.9",
    transform: "translate(-78.458 -49.631)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87559",
    "data-name": "Group 87559",
    transform: "translate(100.505 128.845)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87558",
    "data-name": "Group 87558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87557",
    "data-name": "Group 87557",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275952",
    "data-name": "Path 275952",
    d: "M109.04,118.573v10.38a3.9,3.9,0,0,1-1.918-.456L80.374,113.055a4.24,4.24,0,0,1-1.918-3.32v-5.957a4.289,4.289,0,0,1,1.723-3.2c-.86.615-.793,1.519.195,2.091l26.749,15.441a3.918,3.918,0,0,0,1.918.461",
    transform: "translate(-78.457 -100.58)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275953",
    "data-name": "Path 275953",
    d: "M158.5,49.928l26.746,15.443a2.214,2.214,0,0,1,.811,3.024L169.383,97.276a9.737,9.737,0,0,1-3.025,3.024L110.711,132.43a4.241,4.241,0,0,1-3.835,0L80.129,116.987a1.169,1.169,0,0,1,0-2.215c3.742-4.04,9.007-7.324,14.273-8.24a25.645,25.645,0,0,1,14.391-8.309c3.834-5.02,8.711-7.822,14.391-8.309a22.21,22.21,0,0,1,12.592-7.271A9.75,9.75,0,0,0,138.8,79.62c1.829-6.009,4.172-10.477,9.611-14.606,1.12-5.289,3.048-10.7,7.064-14.274a2.214,2.214,0,0,1,3.024-.811",
    transform: "translate(22.295 13.947)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87562",
    "data-name": "Group 87562",
    transform: "translate(101.63 63.578)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87561",
    "data-name": "Group 87561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87560",
    "data-name": "Group 87560",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275954",
    "data-name": "Path 275954",
    d: "M158.5,49.928l26.746,15.443a2.214,2.214,0,0,1,.811,3.024L169.383,97.276a9.737,9.737,0,0,1-3.025,3.024L110.711,132.43a4.241,4.241,0,0,1-3.835,0L80.129,116.987a1.169,1.169,0,0,1,0-2.215c3.742-4.04,9.007-7.324,14.273-8.24a25.645,25.645,0,0,1,14.391-8.309c3.834-5.02,8.711-7.822,14.391-8.309a22.21,22.21,0,0,1,12.592-7.271A9.75,9.75,0,0,0,138.8,79.62c1.829-6.009,4.172-10.477,9.611-14.606,1.12-5.289,3.048-10.7,7.064-14.274a2.214,2.214,0,0,1,3.024-.811",
    transform: "translate(-79.335 -49.631)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87565",
    "data-name": "Group 87565",
    transform: "translate(159.605 63.578)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87564",
    "data-name": "Group 87564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87563",
    "data-name": "Group 87563",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275955",
    "data-name": "Path 275955",
    d: "M172.529,65.37,145.783,49.927a2.214,2.214,0,0,0-3.024.811c-4.016,3.571-5.944,8.986-7.064,14.274-5.44,4.13-7.782,8.6-9.611,14.606a9,9,0,0,1-1.491,1.82l0,.008L155.17,99.1a9,9,0,0,0,1.495-1.823L173.34,68.394a2.214,2.214,0,0,0-.811-3.024",
    transform: "translate(-124.592 -49.631)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87568",
    "data-name": "Group 87568",
    transform: "translate(177.651 72.164)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87567",
    "data-name": "Group 87567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87566",
    "data-name": "Group 87566",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275956",
    "data-name": "Path 275956",
    d: "M146.381,62.034a5.556,5.556,0,0,1-2.508-1.1,3.171,3.171,0,0,1-.519-.635,2.21,2.21,0,0,0-.38-.6.325.325,0,0,0-.181-.058,3.388,3.388,0,0,1,.662-1.729,5.971,5.971,0,0,1,.6-.813c.2-.209.443-.391.62-.619.035-.044.017-.156-.054-.151a1.648,1.648,0,0,0-.915.526,4.986,4.986,0,0,0-.862,1.049,4.374,4.374,0,0,0-.441.98,2.45,2.45,0,0,0-.094.451,1.4,1.4,0,0,0-.01.238.751.751,0,0,0-.292-.118,5.511,5.511,0,0,1-1.546-.708,3.847,3.847,0,0,1-1.742-2.009c-.01-.038-.049.012-.044.037a4.041,4.041,0,0,0,.984,1.781,5.391,5.391,0,0,0,1.686,1.066,3.9,3.9,0,0,0,.594.2,2.938,2.938,0,0,0-1.113,1.3,3.785,3.785,0,0,0-.341,2.34c.008.038.042.017.047-.012a8.216,8.216,0,0,1,.191-1.026,5.213,5.213,0,0,1,.415-1.054,2.759,2.759,0,0,1,1.3-1.313.154.154,0,0,0,.11-.188h.01a.289.289,0,0,0,.1-.019,1.7,1.7,0,0,0,.329.633,3.9,3.9,0,0,0,.68.751,3.813,3.813,0,0,0,1.1.647,4.465,4.465,0,0,0,.8.2,2.751,2.751,0,0,0,.8.012c.024,0,.033-.058.008-.064",
    transform: "translate(-138.679 -56.333)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275957",
    "data-name": "Path 275957",
    d: "M142.614,59.839a1.175,1.175,0,1,0-1.51.291,1.092,1.092,0,0,0,1.51-.291",
    transform: "translate(39.478 16.358)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87571",
    "data-name": "Group 87571",
    transform: "translate(148.354 105.926)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87570",
    "data-name": "Group 87570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87569",
    "data-name": "Group 87569",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275958",
    "data-name": "Path 275958",
    d: "M116.031,87.278a4.845,4.845,0,0,1,2.124-1.527,5.539,5.539,0,0,1,.97-.214,4.444,4.444,0,0,0,.883-.123.25.25,0,0,0,.126-.115,5.958,5.958,0,0,1,2.052.908,7.289,7.289,0,0,1,.883.637,8.481,8.481,0,0,0,.626.6c.047.036.2.051.21,0,.065-.26-.191-.553-.423-.788a5.668,5.668,0,0,0-1.117-.881,7.073,7.073,0,0,0-1.143-.561,4.972,4.972,0,0,0-.557-.181,2.893,2.893,0,0,0-.306-.067.618.618,0,0,0,.234-.179,4.94,4.94,0,0,1,1.353-.934,6.453,6.453,0,0,1,3.091-.748c.053,0,0-.038-.036-.041a7.914,7.914,0,0,0-1.319.031,6.715,6.715,0,0,0-1.263.231,6.091,6.091,0,0,0-1.855.943,3.045,3.045,0,0,0-.425.377,3.22,3.22,0,0,0-1.364-1.122,7.98,7.98,0,0,0-2.932-.831c-.053,0-.035.027,0,.037.434.124.862.241,1.273.395a9.126,9.126,0,0,1,1.248.561,2.7,2.7,0,0,1,1.336,1.261.209.209,0,0,0,.211.126l0,.008a.106.106,0,0,0,0,.077,3.568,3.568,0,0,0-.912.078,6.516,6.516,0,0,0-1.163.3,4.043,4.043,0,0,0-1.148.629,2.8,2.8,0,0,0-.491.524,1.29,1.29,0,0,0-.241.571c0,.018.065.038.081.022",
    transform: "translate(-115.809 -82.689)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275959",
    "data-name": "Path 275959",
    d: "M118.47,85.075a2.253,2.253,0,0,0,2.023,0c.571-.319.594-.838.049-1.157a2.253,2.253,0,0,0-2.023,0c-.571.319-.593.837-.049,1.157",
    transform: "translate(33.182 23.516)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87574",
    "data-name": "Group 87574",
    transform: "translate(163.545 114.697)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87573",
    "data-name": "Group 87573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87572",
    "data-name": "Group 87572",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275960",
    "data-name": "Path 275960",
    d: "M127.89,94.124a4.845,4.845,0,0,1,2.124-1.527,5.541,5.541,0,0,1,.97-.214,4.446,4.446,0,0,0,.883-.123.25.25,0,0,0,.126-.115,5.958,5.958,0,0,1,2.052.908,7.29,7.29,0,0,1,.883.637,8.485,8.485,0,0,0,.626.6c.047.036.2.051.21,0,.065-.26-.191-.553-.423-.788a5.67,5.67,0,0,0-1.117-.881,7.073,7.073,0,0,0-1.143-.561,4.974,4.974,0,0,0-.557-.181,2.894,2.894,0,0,0-.306-.067.608.608,0,0,0,.234-.181A4.966,4.966,0,0,1,133.8,90.7a6.453,6.453,0,0,1,3.091-.748c.053,0,0-.038-.036-.041a7.916,7.916,0,0,0-1.319.031,6.717,6.717,0,0,0-1.263.231,6.09,6.09,0,0,0-1.855.943,3.044,3.044,0,0,0-.425.377,3.22,3.22,0,0,0-1.364-1.122,7.98,7.98,0,0,0-2.932-.831c-.053,0-.035.027,0,.037.434.124.862.241,1.273.395a9.123,9.123,0,0,1,1.248.561,2.7,2.7,0,0,1,1.336,1.261.209.209,0,0,0,.211.126l0,.008a.106.106,0,0,0,0,.077,3.566,3.566,0,0,0-.912.078,6.515,6.515,0,0,0-1.163.3,4.043,4.043,0,0,0-1.148.629,2.8,2.8,0,0,0-.491.524,1.29,1.29,0,0,0-.241.571c0,.018.065.038.081.022",
    transform: "translate(-127.668 -89.536)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275961",
    "data-name": "Path 275961",
    d: "M130.329,91.922a2.253,2.253,0,0,0,2.023,0c.571-.319.594-.838.049-1.157a2.253,2.253,0,0,0-2.023,0c-.571.319-.593.837-.049,1.157",
    transform: "translate(36.514 25.44)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87577",
    "data-name": "Group 87577",
    transform: "translate(133.963 114.235)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87576",
    "data-name": "Group 87576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87575",
    "data-name": "Group 87575",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275962",
    "data-name": "Path 275962",
    d: "M104.8,93.764a4.845,4.845,0,0,1,2.124-1.527,5.54,5.54,0,0,1,.97-.214,4.446,4.446,0,0,0,.883-.123.25.25,0,0,0,.126-.115,5.958,5.958,0,0,1,2.052.908,7.29,7.29,0,0,1,.883.637,8.47,8.47,0,0,0,.626.6c.047.036.2.051.21,0,.065-.26-.191-.553-.423-.788a5.669,5.669,0,0,0-1.117-.881,7.074,7.074,0,0,0-1.143-.561,4.972,4.972,0,0,0-.557-.181,2.891,2.891,0,0,0-.306-.067.618.618,0,0,0,.234-.179,4.94,4.94,0,0,1,1.353-.934,6.453,6.453,0,0,1,3.091-.748c.053,0,0-.038-.036-.041a7.916,7.916,0,0,0-1.319.031,6.717,6.717,0,0,0-1.263.231,6.091,6.091,0,0,0-1.855.943,3.045,3.045,0,0,0-.425.377,3.22,3.22,0,0,0-1.364-1.122,7.98,7.98,0,0,0-2.932-.831c-.053,0-.035.027,0,.037.434.124.862.242,1.273.395a9.125,9.125,0,0,1,1.248.561,2.7,2.7,0,0,1,1.336,1.261.209.209,0,0,0,.211.126l0,.008a.106.106,0,0,0,0,.077,3.567,3.567,0,0,0-.912.078,6.515,6.515,0,0,0-1.163.3,4.043,4.043,0,0,0-1.148.629,2.8,2.8,0,0,0-.491.524,1.29,1.29,0,0,0-.241.571c0,.018.065.038.081.022",
    transform: "translate(-104.575 -89.175)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275963",
    "data-name": "Path 275963",
    d: "M107.236,91.561a2.253,2.253,0,0,0,2.023,0c.571-.319.594-.838.049-1.157a2.253,2.253,0,0,0-2.023,0c-.571.319-.593.837-.049,1.157",
    transform: "translate(30.025 25.338)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87580",
    "data-name": "Group 87580",
    transform: "translate(149.153 123.006)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87579",
    "data-name": "Group 87579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87578",
    "data-name": "Group 87578",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275964",
    "data-name": "Path 275964",
    d: "M116.656,100.61a4.845,4.845,0,0,1,2.124-1.527,5.538,5.538,0,0,1,.97-.214,4.445,4.445,0,0,0,.883-.123.25.25,0,0,0,.126-.115,5.958,5.958,0,0,1,2.052.908,7.289,7.289,0,0,1,.883.637,8.476,8.476,0,0,0,.626.6c.047.036.2.051.21,0,.065-.26-.191-.553-.423-.788a5.7,5.7,0,0,0-1.116-.881,7.142,7.142,0,0,0-1.144-.561,4.972,4.972,0,0,0-.557-.181,2.888,2.888,0,0,0-.306-.067.618.618,0,0,0,.234-.179,4.94,4.94,0,0,1,1.353-.934,6.453,6.453,0,0,1,3.091-.748c.053,0,0-.038-.036-.041a7.915,7.915,0,0,0-1.319.031,6.716,6.716,0,0,0-1.263.231,6.091,6.091,0,0,0-1.855.943,3.045,3.045,0,0,0-.425.377,3.221,3.221,0,0,0-1.364-1.122,7.98,7.98,0,0,0-2.932-.831c-.053,0-.035.027,0,.037.434.124.862.242,1.273.395a9.125,9.125,0,0,1,1.248.561,2.7,2.7,0,0,1,1.336,1.261.209.209,0,0,0,.211.126l0,.008a.106.106,0,0,0,0,.077,3.567,3.567,0,0,0-.912.078,6.516,6.516,0,0,0-1.163.3,4.042,4.042,0,0,0-1.148.629,2.8,2.8,0,0,0-.491.524,1.291,1.291,0,0,0-.241.571c0,.018.065.038.081.022",
    transform: "translate(-116.433 -96.022)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275965",
    "data-name": "Path 275965",
    d: "M119.095,98.408a2.253,2.253,0,0,0,2.023,0c.571-.319.594-.838.049-1.157a2.253,2.253,0,0,0-2.023,0c-.571.319-.593.837-.049,1.157",
    transform: "translate(33.357 27.263)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87583",
    "data-name": "Group 87583",
    transform: "translate(118.715 122.05)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87582",
    "data-name": "Group 87582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87581",
    "data-name": "Group 87581",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275966",
    "data-name": "Path 275966",
    d: "M92.895,99.864a4.845,4.845,0,0,1,2.124-1.527,5.539,5.539,0,0,1,.97-.214A4.444,4.444,0,0,0,96.871,98,.25.25,0,0,0,97,97.884a5.958,5.958,0,0,1,2.052.908,7.288,7.288,0,0,1,.883.637,8.474,8.474,0,0,0,.626.6c.047.036.2.051.21,0,.065-.26-.191-.553-.423-.788a5.668,5.668,0,0,0-1.117-.881,7.075,7.075,0,0,0-1.143-.561,4.976,4.976,0,0,0-.557-.181,2.891,2.891,0,0,0-.306-.067.618.618,0,0,0,.234-.179,4.94,4.94,0,0,1,1.353-.934,6.453,6.453,0,0,1,3.091-.748c.053,0,0-.038-.036-.041a7.916,7.916,0,0,0-1.319.031,6.718,6.718,0,0,0-1.263.231,6.09,6.09,0,0,0-1.855.943,3.043,3.043,0,0,0-.425.377,3.22,3.22,0,0,0-1.364-1.122,7.98,7.98,0,0,0-2.932-.831c-.053,0-.035.027,0,.037.434.124.862.242,1.273.395a9.122,9.122,0,0,1,1.248.561,2.7,2.7,0,0,1,1.336,1.261.209.209,0,0,0,.211.126l0,.008a.106.106,0,0,0,0,.077,3.567,3.567,0,0,0-.912.078,6.514,6.514,0,0,0-1.163.3,4.043,4.043,0,0,0-1.148.629,2.8,2.8,0,0,0-.491.524,1.29,1.29,0,0,0-.241.571c0,.018.065.038.081.022",
    transform: "translate(-92.672 -95.275)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275967",
    "data-name": "Path 275967",
    d: "M95.334,97.661a2.253,2.253,0,0,0,2.023,0c.571-.319.594-.838.049-1.157a2.257,2.257,0,0,0-2.023,0c-.571.319-.593.837-.049,1.157",
    transform: "translate(26.68 27.053)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87586",
    "data-name": "Group 87586",
    transform: "translate(133.906 130.82)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87585",
    "data-name": "Group 87585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87584",
    "data-name": "Group 87584",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275968",
    "data-name": "Path 275968",
    d: "M104.753,106.711a4.845,4.845,0,0,1,2.124-1.527,5.539,5.539,0,0,1,.97-.214,4.445,4.445,0,0,0,.883-.123.25.25,0,0,0,.126-.115,5.958,5.958,0,0,1,2.052.908,7.289,7.289,0,0,1,.883.637,8.474,8.474,0,0,0,.626.6c.047.036.2.051.21,0,.065-.26-.191-.553-.423-.788a5.7,5.7,0,0,0-1.116-.881,7.141,7.141,0,0,0-1.144-.561,4.977,4.977,0,0,0-.557-.181,2.89,2.89,0,0,0-.306-.067.619.619,0,0,0,.234-.179,4.941,4.941,0,0,1,1.353-.934,6.453,6.453,0,0,1,3.091-.748c.053,0,0-.038-.036-.041a7.916,7.916,0,0,0-1.319.031,6.718,6.718,0,0,0-1.263.231,6.091,6.091,0,0,0-1.855.943,3.044,3.044,0,0,0-.425.377,3.22,3.22,0,0,0-1.364-1.122,7.98,7.98,0,0,0-2.932-.831c-.053,0-.035.027,0,.037.434.124.862.242,1.273.395a9.123,9.123,0,0,1,1.248.561,2.7,2.7,0,0,1,1.336,1.261.209.209,0,0,0,.211.126l0,.008a.106.106,0,0,0,0,.077,3.567,3.567,0,0,0-.912.078,6.515,6.515,0,0,0-1.163.3,4.043,4.043,0,0,0-1.148.629,2.8,2.8,0,0,0-.491.524,1.29,1.29,0,0,0-.241.571c0,.018.065.038.081.022",
    transform: "translate(-104.531 -102.122)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275969",
    "data-name": "Path 275969",
    d: "M107.192,104.508a2.253,2.253,0,0,0,2.023,0c.571-.319.594-.838.049-1.157a2.253,2.253,0,0,0-2.023,0c-.571.319-.593.837-.049,1.157",
    transform: "translate(30.012 28.977)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87589",
    "data-name": "Group 87589",
    transform: "translate(194.05 81.467)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87588",
    "data-name": "Group 87588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87587",
    "data-name": "Group 87587",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275970",
    "data-name": "Path 275970",
    d: "M159.183,69.3a5.556,5.556,0,0,1-2.508-1.1,3.171,3.171,0,0,1-.519-.635,2.21,2.21,0,0,0-.38-.6.336.336,0,0,0-.181-.058,3.388,3.388,0,0,1,.662-1.729,5.967,5.967,0,0,1,.6-.813c.2-.209.443-.391.62-.619.035-.044.017-.156-.054-.151a1.648,1.648,0,0,0-.915.527,4.986,4.986,0,0,0-.862,1.049,4.375,4.375,0,0,0-.441.98,2.453,2.453,0,0,0-.094.451,1.4,1.4,0,0,0-.01.238.752.752,0,0,0-.292-.118,5.512,5.512,0,0,1-1.546-.708A3.848,3.848,0,0,1,151.525,64c-.01-.038-.049.012-.044.037a4.042,4.042,0,0,0,.984,1.781,5.378,5.378,0,0,0,1.686,1.066,3.9,3.9,0,0,0,.594.2,2.938,2.938,0,0,0-1.113,1.3,3.8,3.8,0,0,0-.342,2.34c.009.038.044.017.049-.012a8.152,8.152,0,0,1,.191-1.025,5.2,5.2,0,0,1,.415-1.056,2.759,2.759,0,0,1,1.3-1.313.154.154,0,0,0,.11-.188h.01a.289.289,0,0,0,.1-.019,1.7,1.7,0,0,0,.329.633,3.9,3.9,0,0,0,.68.751,3.812,3.812,0,0,0,1.1.647,4.465,4.465,0,0,0,.8.2,2.751,2.751,0,0,0,.8.012c.024,0,.033-.058.008-.064",
    transform: "translate(-151.481 -63.595)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275971",
    "data-name": "Path 275971",
    d: "M155.417,67.1a1.175,1.175,0,1,0-1.51.291,1.092,1.092,0,0,0,1.51-.291",
    transform: "translate(43.076 18.399)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87592",
    "data-name": "Group 87592",
    transform: "translate(169.37 85.937)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87591",
    "data-name": "Group 87591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87590",
    "data-name": "Group 87590",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275972",
    "data-name": "Path 275972",
    d: "M139.917,72.786a5.556,5.556,0,0,1-2.508-1.1,3.173,3.173,0,0,1-.519-.635,2.211,2.211,0,0,0-.38-.6.336.336,0,0,0-.181-.058,3.389,3.389,0,0,1,.662-1.729,5.971,5.971,0,0,1,.6-.813c.2-.209.443-.391.62-.619.035-.044.017-.156-.054-.151a1.648,1.648,0,0,0-.915.527,4.987,4.987,0,0,0-.862,1.049,4.373,4.373,0,0,0-.441.98,2.449,2.449,0,0,0-.094.451,1.392,1.392,0,0,0-.01.238.752.752,0,0,0-.292-.118A5.512,5.512,0,0,1,134,69.5a3.848,3.848,0,0,1-1.742-2.009c-.01-.038-.049.012-.044.037a4.041,4.041,0,0,0,.984,1.781,5.377,5.377,0,0,0,1.686,1.066,3.9,3.9,0,0,0,.594.2,2.938,2.938,0,0,0-1.113,1.3,3.8,3.8,0,0,0-.342,2.34c.009.038.044.017.049-.012a8.164,8.164,0,0,1,.191-1.025,5.2,5.2,0,0,1,.415-1.056,2.759,2.759,0,0,1,1.3-1.313.154.154,0,0,0,.11-.188h.01a.289.289,0,0,0,.1-.019,1.7,1.7,0,0,0,.329.633,3.906,3.906,0,0,0,.68.751,3.812,3.812,0,0,0,1.1.647,4.463,4.463,0,0,0,.8.2,2.75,2.75,0,0,0,.8.012c.024,0,.033-.058.008-.064",
    transform: "translate(-132.215 -67.085)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275973",
    "data-name": "Path 275973",
    d: "M136.151,70.591a1.175,1.175,0,1,0-1.51.291,1.092,1.092,0,0,0,1.51-.291",
    transform: "translate(37.662 19.38)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87595",
    "data-name": "Group 87595",
    transform: "translate(185.544 95.428)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87594",
    "data-name": "Group 87594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87593",
    "data-name": "Group 87593",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275974",
    "data-name": "Path 275974",
    d: "M152.543,80.194a5.556,5.556,0,0,1-2.508-1.1,3.171,3.171,0,0,1-.519-.635,2.21,2.21,0,0,0-.38-.6.336.336,0,0,0-.181-.058,3.389,3.389,0,0,1,.662-1.729,5.969,5.969,0,0,1,.6-.813c.2-.209.443-.391.62-.619.035-.044.017-.156-.054-.151a1.648,1.648,0,0,0-.915.527,4.987,4.987,0,0,0-.862,1.049,4.372,4.372,0,0,0-.441.98,2.449,2.449,0,0,0-.094.451,1.4,1.4,0,0,0-.01.238.754.754,0,0,0-.291-.118,5.5,5.5,0,0,1-1.547-.708,3.847,3.847,0,0,1-1.742-2.009c-.01-.038-.049.012-.044.037a4.042,4.042,0,0,0,.984,1.781,5.392,5.392,0,0,0,1.686,1.066,3.9,3.9,0,0,0,.594.2,2.938,2.938,0,0,0-1.113,1.3,3.785,3.785,0,0,0-.341,2.34c.008.038.042.017.047-.012a8.157,8.157,0,0,1,.191-1.025,5.2,5.2,0,0,1,.415-1.056,2.759,2.759,0,0,1,1.3-1.313.154.154,0,0,0,.11-.188h.01a.288.288,0,0,0,.1-.019,1.7,1.7,0,0,0,.329.633,3.947,3.947,0,0,0,.68.751,3.813,3.813,0,0,0,1.1.647,4.465,4.465,0,0,0,.8.2,2.751,2.751,0,0,0,.8.012c.024,0,.033-.058.008-.064",
    transform: "translate(-144.841 -74.494)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275975",
    "data-name": "Path 275975",
    d: "M148.776,78a1.175,1.175,0,1,0-1.51.291,1.092,1.092,0,0,0,1.51-.291",
    transform: "translate(41.21 21.462)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87598",
    "data-name": "Group 87598",
    transform: "translate(112.513 63.578)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87597",
    "data-name": "Group 87597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87596",
    "data-name": "Group 87596",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275976",
    "data-name": "Path 275976",
    d: "M173.986,76.689c-1.784,1.312-4.224,2.706-6.023,1.417-1.567-1.121-1.4-3.548-.544-5.275s2.223-3.229,2.645-5.109c.959-4.27-3.241-8.047-4.272-12.206l-9.678-5.588a2.216,2.216,0,0,0-3.026.811c-.088.078-.17.163-.257.243-.2.428-.38.862-.564,1.293q-.509,1.2-1.013,2.408a71.024,71.024,0,0,0-3.127,8.774,14.269,14.269,0,0,0-.383,1.927A7.247,7.247,0,0,1,147,67.249c-.616,1.408-1.162,2.846-1.681,4.294-.934,2.611-1.779,5.253-2.8,7.833a31.878,31.878,0,0,1-3.624,7.179,13.064,13.064,0,0,1-3.15,2.567,32.671,32.671,0,0,1-3.551,2.078,74.882,74.882,0,0,1-7.572,3.208c-1.368.516-2.738,1.03-4.093,1.576a44.616,44.616,0,0,0-7.379,3.643,40.2,40.2,0,0,0-6.491,5.38c-2.138,2.112-4.075,4.434-6.34,6.41a28.624,28.624,0,0,1-8.749,5.221,12.46,12.46,0,0,0-2.844,1.19,2,2,0,0,0-.889,1.36,1.875,1.875,0,0,0,.468,1.363,3.75,3.75,0,0,0,1.177.88,7.778,7.778,0,0,0,7.193-.086c1.446-.794,2.616-2.045,4.111-2.744a12,12,0,0,1,2.506-.763,1.425,1.425,0,0,1,.8-.022c1.6.588-2.876,3.012-3.333,3.285-.812.487-1.64.949-2.407,1.5-.562.406-1.62,1.043-1.664,1.806a1.582,1.582,0,0,0,.423,1.1,3.468,3.468,0,0,0,.967.723,9.216,9.216,0,0,0,3.673,1.012,7.72,7.72,0,0,0,5.123-1.271,16.734,16.734,0,0,1,2.836-1.984c1.075-.447,2.371-.439,3.244-1.209a6.07,6.07,0,0,0,1.145-1.767c.815-1.5,2.753-2.358,4.188-3.19a24.646,24.646,0,0,0,4.7-3.2c1.857-1.752,3.08-4.06,4.686-6.044a13.022,13.022,0,0,1,6.865-4.6l2.739-.669c1.572-.384,3.138-.813,4.721-1.153,1.353-.291,2.734-.479,4.092-.765a22.363,22.363,0,0,0,7.863-2.958c.252-.168.5-.345.742-.529,4.275-3.267,6.031-8.78,7.552-13.941,1.263,2.659,4.719,3.657,7.6,3.031a13.119,13.119,0,0,0,4.1-1.752l5.713-9.9c-1.642-1.047-4,.109-5.663,1.33",
    transform: "translate(-87.831 -49.631)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275977",
    "data-name": "Path 275977",
    d: "M102.814,89.957s-4.165,8.095-5.713,10A18.453,18.453,0,0,1,92.833,104c-.393.281-1.254.771-1.576,1a.572.572,0,0,0-.15.871c.482.753,3.11,1.544,4.874.787s3.7-2.808,4.81-3.492c.416-.257.815-.527,1.2-.821.374-.283.377-.639.5-1.029.059-.19.159-.719.159-.719.432-.888,4.938-6.171,5.455-7.012Z",
    transform: "translate(25.565 25.28)",
    fill: "#febc69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275978",
    "data-name": "Path 275978",
    d: "M103.008,101.641a2.079,2.079,0,0,1-.233.662,7.436,7.436,0,0,1-2.358.938,3.24,3.24,0,0,0-1.952,1.372,5.568,5.568,0,0,1-3.306,1.947,8.86,8.86,0,0,1-5.234-.524c-2.064-.828-1.978-2.126-1.978-2.126s.132-1.213.7-1.291,14.359-.977,14.359-.977",
    transform: "translate(24.715 28.563)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275979",
    "data-name": "Path 275979",
    d: "M103.588,98.478c.051.038.152.1.155.357,0,.1-.3,1.086-.363,1.678a6.65,6.65,0,0,1-.434,2.566c-1.373.917-3.213.842-4.32,1.86s-2.212,2.346-5.136,2.325-4.87-1.351-5.224-2.257.274-1.562,2.274-2.162c2.123-.638,5.269-3.194,5.27-3.195a12.991,12.991,0,0,0,1.231-1.173,10.96,10.96,0,0,0,.926-1.4,1.242,1.242,0,0,1,.559-.52,1.271,1.271,0,0,1,.762.056,5.6,5.6,0,0,1,1.163.428,1.876,1.876,0,0,1,.851.875,8.6,8.6,0,0,0,.284.851,1.085,1.085,0,0,0,1,.55.927.927,0,0,0,.884-.612,2.258,2.258,0,0,0,.117-.228",
    transform: "translate(24.778 27.124)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275980",
    "data-name": "Path 275980",
    d: "M95.465,105.675a3.641,3.641,0,0,0-1.451-3.477c-1.895-1.518-3.326-1.085-4.069-.752-.886.4-2.228,1.328-1.731,2.308.535,1.058,1.605,1.729,3.761,2.2a5.254,5.254,0,0,0,3.49-.279",
    transform: "translate(24.76 28.417)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275981",
    "data-name": "Path 275981",
    d: "M97.873,100.554a.251.251,0,0,1-.172-.14,3.73,3.73,0,0,0-3.027-1.846c-.041-.188.12-.339.464-.46a4.458,4.458,0,0,1,3.019,2.124.232.232,0,0,1-.129.311.269.269,0,0,1-.155.01",
    transform: "translate(26.604 27.571)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275982",
    "data-name": "Path 275982",
    d: "M93.827,99.3a.75.75,0,0,1,.528-.43,4.539,4.539,0,0,1,2.822,2.1.233.233,0,0,1-.129.311.269.269,0,0,1-.155.01.254.254,0,0,1-.172-.14A3.808,3.808,0,0,0,93.827,99.3",
    transform: "translate(26.367 27.784)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275983",
    "data-name": "Path 275983",
    d: "M91.616,100.818a1.379,1.379,0,0,1,.794-.488,4.487,4.487,0,0,1,2.954,2.116.231.231,0,0,1-.129.311.269.269,0,0,1-.155.01.257.257,0,0,1-.172-.14c-.181-.406-1.6-2.13-3.292-1.81",
    transform: "translate(25.746 28.195)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275984",
    "data-name": "Path 275984",
    d: "M95.96,102.026a.251.251,0,0,1-.172-.14,3.764,3.764,0,0,0-2.976-1.847.853.853,0,0,1,.61-.432,4.535,4.535,0,0,1,2.822,2.1.232.232,0,0,1-.129.311.269.269,0,0,1-.155.01",
    transform: "translate(26.082 27.992)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275985",
    "data-name": "Path 275985",
    d: "M110.225,94.518s-4.416,7.358-5.964,9.267a19.432,19.432,0,0,1-4.405,4.127c-.395.281-1.255.771-1.577,1a.573.573,0,0,0-.149.871c.482.753,3.109,1.544,4.873.787s3.7-2.808,4.81-3.492c.418-.257.816-.527,1.2-.821s.378-.639.5-1.029c.059-.19.159-.719.159-.719.43-.886,5.36-5.478,6.177-6.433Z",
    transform: "translate(27.538 26.561)",
    fill: "#febc69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275986",
    "data-name": "Path 275986",
    d: "M110.03,105.694a2.079,2.079,0,0,1-.233.662,7.436,7.436,0,0,1-2.358.938,3.24,3.24,0,0,0-1.952,1.372,5.568,5.568,0,0,1-3.306,1.947,8.86,8.86,0,0,1-5.234-.524c-2.064-.828-1.978-2.127-1.978-2.127s.132-1.213.7-1.291,14.359-.977,14.359-.977",
    transform: "translate(26.688 29.702)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275987",
    "data-name": "Path 275987",
    d: "M110.609,102.532c.051.038.152.1.155.357,0,.1-.3,1.086-.363,1.678a6.65,6.65,0,0,1-.434,2.566c-1.373.917-3.213.842-4.32,1.86s-2.212,2.346-5.136,2.325-4.87-1.351-5.224-2.257.274-1.562,2.274-2.162c2.123-.638,5.269-3.194,5.27-3.195a12.987,12.987,0,0,0,1.231-1.173,10.96,10.96,0,0,0,.926-1.4,1.242,1.242,0,0,1,.559-.52,1.271,1.271,0,0,1,.762.056,5.6,5.6,0,0,1,1.163.428,1.876,1.876,0,0,1,.851.875,8.6,8.6,0,0,0,.284.851,1.085,1.085,0,0,0,1,.55.927.927,0,0,0,.884-.612,2.26,2.26,0,0,0,.117-.228",
    transform: "translate(26.751 28.263)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275988",
    "data-name": "Path 275988",
    d: "M102.487,109.729a3.641,3.641,0,0,0-1.451-3.477c-1.895-1.518-3.326-1.085-4.069-.752-.886.4-2.228,1.328-1.731,2.308.535,1.058,1.605,1.729,3.761,2.2a5.254,5.254,0,0,0,3.489-.279",
    transform: "translate(26.733 29.557)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275989",
    "data-name": "Path 275989",
    d: "M104.894,104.608a.251.251,0,0,1-.172-.14,3.73,3.73,0,0,0-3.027-1.846c-.041-.188.12-.339.464-.46a4.458,4.458,0,0,1,3.019,2.124.232.232,0,0,1-.129.311.269.269,0,0,1-.155.01",
    transform: "translate(28.577 28.71)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275990",
    "data-name": "Path 275990",
    d: "M100.848,103.352a.75.75,0,0,1,.528-.43,4.535,4.535,0,0,1,2.822,2.1.233.233,0,0,1-.129.311.269.269,0,0,1-.155.01.254.254,0,0,1-.172-.14,3.808,3.808,0,0,0-2.894-1.849",
    transform: "translate(28.34 28.923)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275991",
    "data-name": "Path 275991",
    d: "M98.638,104.872a1.379,1.379,0,0,1,.794-.488,4.487,4.487,0,0,1,2.954,2.116.231.231,0,0,1-.129.311.269.269,0,0,1-.155.01.257.257,0,0,1-.172-.14c-.181-.406-1.6-2.13-3.292-1.81",
    transform: "translate(27.719 29.334)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275992",
    "data-name": "Path 275992",
    d: "M102.982,106.08a.251.251,0,0,1-.172-.14,3.764,3.764,0,0,0-2.976-1.847.853.853,0,0,1,.61-.432,4.535,4.535,0,0,1,2.822,2.1.232.232,0,0,1-.129.311.269.269,0,0,1-.155.01",
    transform: "translate(28.056 29.131)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275993",
    "data-name": "Path 275993",
    d: "M144.63,71.491c-.038,3.165-.036,5.625-1.7,8.51s-4.881,4.527-9.661,6.123c-3.957,1.321-14.264,1.8-15.924,2.1-1.158.213-2.512.336-3.3,1.96-.9,1.856-1.1,2.043-3.472,4.417-3.062,3.071-3.739,3.706-6,5.783-1.551.5-4.609-1.458-5.47-2.986,0,0,6.728-12.53,8.465-14.773,1.852-2.392,12.531-5.74,17.465-7.207,1.644-.489,10.39-2.283,10.39-2.283Z",
    transform: "translate(27.852 20.09)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275994",
    "data-name": "Path 275994",
    d: "M144.63,71.491c-.038,3.165-.036,5.625-1.7,8.51s-4.881,4.527-9.661,6.123c-3.957,1.321-14.264,1.8-15.924,2.1-1.158.213-2.512.336-3.3,1.96-.9,1.856-1.1,2.043-3.472,4.417-3.062,3.071-3.739,3.706-6,5.783-1.551.5-4.609-1.458-5.47-2.986,0,0,6.728-12.53,8.465-14.773,1.852-2.392,12.531-5.74,17.465-7.207,1.644-.489,10.39-2.283,10.39-2.283Z",
    transform: "translate(27.852 20.09)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275995",
    "data-name": "Path 275995",
    d: "M114.85,87.317c1.66-.306,11.965-.784,15.923-2.1h0c4.781-1.6,7.995-3.238,9.661-6.123.127-.22.242-.438.35-.655.026-.049.049-.1.072-.147l.006-.012c.087-.181.169-.361.245-.539l.017-.04.027-.063a11.3,11.3,0,0,0,.457-1.343l-8.448-1.556a15.519,15.519,0,0,0,.438,4.924s-12.682,3.147-15.17,4.089c-2.93,1.108-6.693,1.687-7.292,4.216a14.031,14.031,0,0,1-3.156,5.83c.035-.033.065-.064.1-.1,2.367-2.374,2.575-2.561,3.472-4.417.785-1.624,2.139-1.746,3.3-1.96",
    transform: "translate(30.345 21.002)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275996",
    "data-name": "Path 275996",
    d: "M106.8,101.648c1.3,2.773,5.192,3.875,5.192,3.875s2.457-2.135,5.645-5.073a18.709,18.709,0,0,0,3.61-4.659c.971-1.528,2.351-1.378,3.5-1.628s11.87-1.235,15.94-2.146c3.629-.813,6.151-2.138,8.255-4.721.224-.273.432-.553.626-.842,1.162-1.705,1.877-3.776,2.547-7.349L137.632,74.5l-4.386-1.4-.106-.032c.02.461.309,1.881.393,2.356a24.076,24.076,0,0,0,1.895,5.63l0,.012s-17.387,4.154-19.856,7.344c-1.738,2.243-8.779,13.238-8.779,13.238",
    transform: "translate(30.012 20.534)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275997",
    "data-name": "Path 275997",
    d: "M138.612,41.661a9.528,9.528,0,0,1,9.877.752c3.751,2.848,3.516,6.97,3.588,11.9.049,3.356.641,7.336,2.183,10.2,1.678,3.123,2.311,6.565-.685,8.983s-11.159,2.284-14.391,1.444-9.286-3.869-7.7-9.38,4.291-4.669,4.864-8.56,2.261-15.348,2.261-15.348",
    transform: "translate(36.877 11.416)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275998",
    "data-name": "Path 275998",
    d: "M126.264,58.928a7.731,7.731,0,0,1,.323-1.189,11.318,11.318,0,0,0-.015-5.794c-.065-.325-.135-.651-.2-.975a3.58,3.58,0,0,1-.088-.474c-.013-.152-.028-.279-.216-.319a.56.56,0,0,0-.387.092,1.623,1.623,0,0,0-.687,1.117,7.891,7.891,0,0,0-.058,1.349c-.005.345-.318.106-.448-.028a7.048,7.048,0,0,1-1.17-2.971,12.009,12.009,0,0,0-.384-1.74,1.825,1.825,0,0,0-.66-.867c-.21-.137-.448-.192-.593.086a1.265,1.265,0,0,0-.082.573,1.35,1.35,0,0,1-.322,1.058,3.115,3.115,0,0,0-.562.57,9.137,9.137,0,0,0-.309.972c-.127.277-.386.441-.532.689a2.5,2.5,0,0,0-.155,1.034,8.193,8.193,0,0,0,.2,2.142A15.658,15.658,0,0,0,121,57.336a4.309,4.309,0,0,1,.518,1.733,9.358,9.358,0,0,1-.236,1.813c-.15.749-.252,1.509-.464,2.244-1.861,6.5-1.558,7.663-.564,10.24.348.9,1.736,2.4,5.042,1,3.665-1.547,11.448-6.305,11.448-6.305l4.934-8.489a15.967,15.967,0,0,0-2.348-.478,6.507,6.507,0,0,0-4.06,1.327C132.634,62.247,125.81,67,125.81,67s.351-6.966.453-8.068",
    transform: "translate(33.572 13.213)",
    fill: "#febc69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275999",
    "data-name": "Path 275999",
    d: "M123.611,52.5a5.945,5.945,0,0,0-.564,3.256,3.474,3.474,0,0,1-.255-1.773,1.965,1.965,0,0,1,.819-1.483",
    transform: "translate(34.497 14.753)",
    fill: "#fd9717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276000",
    "data-name": "Path 276000",
    d: "M140.287,56.87a6.376,6.376,0,0,0-4.236-.281c-2.164.582-10.48,6.738-10.9,6.891s-.7.264-.7.264l-.032.632a10.626,10.626,0,0,1,.925,4.389,6.615,6.615,0,0,1-.925,2.758,1.107,1.107,0,0,0,1.194.3,17.139,17.139,0,0,0,2.214-1.446c.674-.37,9.008-5.193,9.008-5.193Z",
    transform: "translate(34.964 15.833)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87601",
    "data-name": "Group 87601",
    transform: "translate(159.383 72.173)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87600",
    "data-name": "Group 87600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87599",
    "data-name": "Group 87599",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276001",
    "data-name": "Path 276001",
    d: "M140.287,56.87a6.376,6.376,0,0,0-4.236-.281c-2.164.582-10.48,6.738-10.9,6.891s-.7.264-.7.264l-.032.632a10.626,10.626,0,0,1,.925,4.389,6.615,6.615,0,0,1-.925,2.758,1.107,1.107,0,0,0,1.194.3,17.139,17.139,0,0,0,2.214-1.446c.674-.37,9.008-5.193,9.008-5.193Z",
    transform: "translate(-124.419 -56.34)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276002",
    "data-name": "Path 276002",
    d: "M124.925,62.614a6.8,6.8,0,0,1,0,7.147,6.86,6.86,0,0,1-2.3.748c.986-.715,2.54-3.128,2.3-7.286Z",
    transform: "translate(34.459 17.596)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276003",
    "data-name": "Path 276003",
    d: "M146.135,58.095l3.817,1.423s1.638,1,1.692,5.808a24.379,24.379,0,0,1-.61,6.4,50.931,50.931,0,0,1-5.856,16.456,47.246,47.246,0,0,1-10.335-4.42c-5.808-3.355-7.383-6.477-7.383-6.477l4.423-3.541,1.161-5.3s-2.133-2.339-1.093-5.046c1.442-3.753,7.479-6.64,7.479-6.64Z",
    transform: "translate(35.819 15.949)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276004",
    "data-name": "Path 276004",
    d: "M136.008,43.468c-.523.473-2.367,2.275-2.367,8.167,0,5.042,1.4,6.241,2.188,6.657a7.1,7.1,0,0,0,3.6.266l-.186,2.428s-7.3,5.279-2.866,6.773,9.422-5.21,9.422-5.21l.521-7.149s.829.936,2.445-.273c1.335-1,1.9-2.812,1-3.876a2.188,2.188,0,0,0-3.522.427s-3.564-1.471-2.712-7.276c-3.024.282-5.834.3-7.521-.933",
    transform: "translate(37.556 12.215)",
    fill: "#febc69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276005",
    "data-name": "Path 276005",
    d: "M138.084,49.221a.628.628,0,1,0,.7-.57.636.636,0,0,0-.7.57",
    transform: "translate(38.803 13.671)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276006",
    "data-name": "Path 276006",
    d: "M136.229,46.853l-1.464.494a.742.742,0,0,0,.954.5.812.812,0,0,0,.51-.994",
    transform: "translate(37.872 13.167)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276007",
    "data-name": "Path 276007",
    d: "M139.917,48l-1.267-.885a.743.743,0,0,0,.164,1.065.813.813,0,0,0,1.1-.179",
    transform: "translate(38.92 13.239)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276008",
    "data-name": "Path 276008",
    d: "M134.373,48.807a.628.628,0,1,0,.7-.57.638.638,0,0,0-.7.57",
    transform: "translate(37.76 13.554)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276009",
    "data-name": "Path 276009",
    d: "M137.542,48.19l-.378,4-2.129-.684Z",
    transform: "translate(37.948 13.542)",
    fill: "#fd9717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276010",
    "data-name": "Path 276010",
    d: "M138.175,55.878a9.943,9.943,0,0,0,3.764-1.068,4.531,4.531,0,0,0,1.831-1.8,3.763,3.763,0,0,1-1.491,2.361,9.255,9.255,0,0,1-4.179,1.506Z",
    transform: "translate(38.809 14.896)",
    fill: "#fd9717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276011",
    "data-name": "Path 276011",
    d: "M138.535,52.858a.717.717,0,1,1-.716-.717.716.716,0,0,1,.716.717",
    transform: "translate(38.528 14.653)",
    fill: "#fd9717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276012",
    "data-name": "Path 276012",
    d: "M140.526,40.821a6.333,6.333,0,0,0-6.663,2.43,6.675,6.675,0,0,0-.98,4.194l2.449.465a9.019,9.019,0,0,1,.858-2.891,7.446,7.446,0,0,0-.11,3.119s1.706.29,3.806.475a10.335,10.335,0,0,1,.669-3.048,12.37,12.37,0,0,0,0,3.087c.965.053,2.7.128,3.5.085L145.624,43a28.318,28.318,0,0,0-5.1-2.183",
    transform: "translate(37.333 11.421)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276013",
    "data-name": "Path 276013",
    d: "M173.849,67.866a1.842,1.842,0,0,0-1.079-.114,11.553,11.553,0,0,0-1.694.571,7.089,7.089,0,0,1-3.146.525c-.183-.038-.553-.192-.26-.374a6.918,6.918,0,0,0,1.126-.746,1.605,1.605,0,0,0,.607-1.154.627.627,0,0,0-.119-.386c-.131-.134-.247-.085-.388-.019a3.42,3.42,0,0,1-.451.169c-.32.111-.629.215-.94.329a11.359,11.359,0,0,0-4.977,2.977,8.186,8.186,0,0,1-.848.89c-.894.657-8.09,3.892-8.09,3.892s-2.62-7.891-3.645-10.934c-.493-1.463-1.258-3-2.308-3.592a7.731,7.731,0,0,0-1.927-.822c-2.7,3.136-2.78,6.257-1.513,9.658,0,0,3.387,8.47,5.391,11.9a6.69,6.69,0,0,0,.423.653c.008.012.015.024.026.027.646.848,1.779,1.179,4.016.222a29.458,29.458,0,0,0,6-3.82c.913-.7,3.427-2.726,3.962-3.046a4.394,4.394,0,0,1,1.751-.452,15.428,15.428,0,0,0,3.2-.664,7.8,7.8,0,0,0,1.939-.933,2.653,2.653,0,0,0,.811-.665,6.1,6.1,0,0,1,.311-.813c.187-.279.512-.464.671-.758a3,3,0,0,0,.2-.785,1.346,1.346,0,0,1,.738-.819,1.219,1.219,0,0,0,.448-.36c.164-.273,0-.446-.231-.559",
    transform: "translate(40.3 16.602)",
    fill: "#febc69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276014",
    "data-name": "Path 276014",
    d: "M162.187,67.206a5.933,5.933,0,0,1-2.5,2.162,3.472,3.472,0,0,0,1.651-.7,1.968,1.968,0,0,0,.848-1.467",
    transform: "translate(44.876 18.886)",
    fill: "#fd9717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276015",
    "data-name": "Path 276015",
    d: "M145.572,58.912c1.768.544,2.741.99,3.629,2.325s3.346,9.314,3.858,10.549,1.227,1.9.634,2.684c0,0-3.852,1.492-5.169,4-1.106.466-.88-.9-1.255-1.677s-3.764-8.963-3.764-8.963-1.9-5.825,2.066-8.92",
    transform: "translate(40.2 16.555)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87604",
    "data-name": "Group 87604",
    transform: "translate(183.251 75.468)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87603",
    "data-name": "Group 87603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87602",
    "data-name": "Group 87602",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276016",
    "data-name": "Path 276016",
    d: "M145.572,58.912c1.768.544,2.741.99,3.629,2.325s3.346,9.314,3.858,10.549,1.227,1.9.634,2.684c0,0-3.852,1.492-5.169,4-1.106.466-.88-.9-1.255-1.677s-3.764-8.963-3.764-8.963-1.9-5.825,2.066-8.92",
    transform: "translate(-143.051 -58.912)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276017",
    "data-name": "Path 276017",
    d: "M152.493,71.058a13.645,13.645,0,0,0-3.442,3.615,5.756,5.756,0,0,0-.772,2.232l-.954-1.845s.51-2.525,5.169-4",
    transform: "translate(41.401 19.969)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276018",
    "data-name": "Path 276018",
    d: "M140.505,59.664l-3.11,2.771,1.563-5.292s-7.311,5.262-2.882,6.756S145.5,58.69,145.5,58.69l.014-.2Z",
    transform: "translate(37.84 16.058)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276019",
    "data-name": "Path 276019",
    d: "M136.794,62.544a38.415,38.415,0,0,1,3.126-3.423c.657-.447,3.026.546,5.068-1.328l.077-1.039s.231-.058.524.69c.3.766.661,1.67.661,1.67a4.008,4.008,0,0,1-1.939,2.832c-2.246,1.5-3.364,1.669-3.7.551a9.119,9.119,0,0,0-.9-2.082Z",
    transform: "translate(38.442 15.949)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276020",
    "data-name": "Path 276020",
    d: "M137.209,62.717l1.563-5.292.109-1.277c-.313-.078-.624.392-1.041.877S135,59.831,135.35,60.888a3.627,3.627,0,0,1,1.948-1.2Z",
    transform: "translate(38.027 15.776)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276021",
    "data-name": "Path 276021",
    d: "M40.245,117.562H35.2l.807,4.922h.008a.906.906,0,0,0,.488.607,2.7,2.7,0,0,0,2.44,0,.908.908,0,0,0,.489-.607h.008Z",
    transform: "translate(9.892 33.037)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276022",
    "data-name": "Path 276022",
    d: "M18.43,105.839H13.384l.807,4.922H14.2a.906.906,0,0,0,.488.607,2.7,2.7,0,0,0,2.44,0,.908.908,0,0,0,.489-.607h.008Z",
    transform: "translate(3.761 29.743)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276023",
    "data-name": "Path 276023",
    d: "M69.735,100.536H64.689l.807,4.922H65.5a.906.906,0,0,0,.488.607,2.7,2.7,0,0,0,2.44,0,.908.908,0,0,0,.489-.607h.008Z",
    transform: "translate(18.179 28.253)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276024",
    "data-name": "Path 276024",
    d: "M49.2,89.433H44.152l.807,4.922h.008a.906.906,0,0,0,.488.607,2.7,2.7,0,0,0,2.44,0,.908.908,0,0,0,.489-.607h.008Z",
    transform: "translate(12.408 25.133)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276025",
    "data-name": "Path 276025",
    d: "M88.4,88.3v23.5a5.424,5.424,0,0,1-2.447,4.238l-1.995,1.153-.033.017a5.511,5.511,0,0,1-3.058.526L50.926,133.582a5.46,5.46,0,0,1-2.419,4.067.056.056,0,0,0-.023.012L46.5,138.807a.926.926,0,0,1-.187.1.753.753,0,0,1-.1.051c-.012.005-.023.005-.028.012a5.578,5.578,0,0,1-3.8.175,3.482,3.482,0,0,1-.424-.159c-.023-.012-.045-.017-.068-.028-.1-.045-.2-.1-.288-.147L12.785,122.214a5.417,5.417,0,0,1-2.447-4.238L10.3,88.226l0-10.321a5.432,5.432,0,0,1,2.447-4.238L44.968,55.1a5.061,5.061,0,0,1,4.722.078l1.995,1.148a6.5,6.5,0,0,1,2.82,4.215l1.92,11.6L58.2,71.111a5.32,5.32,0,0,1,5.324,0L85.958,84.065A5.424,5.424,0,0,1,88.4,88.3",
    transform: "translate(2.893 15.329)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276026",
    "data-name": "Path 276026",
    d: "M51.678,56.325l-1.992-1.15a5.058,5.058,0,0,0-4.722-.078L12.736,73.668c-.143.083-.3.192-.251.156a5.6,5.6,0,0,0-2.17,3.668c.181-1.249,1.2-1.7,2.419-1l1.995,1.152a5.408,5.408,0,0,0,4.893,0L51.678,59.149c1.351-.78,1.351-2.045,0-2.825",
    transform: "translate(2.899 15.329)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276027",
    "data-name": "Path 276027",
    d: "M78.821,84.826v23.5a5.424,5.424,0,0,1-2.447,4.238l-1.995,1.153-.033.017a5.227,5.227,0,0,1-2.866.543,4.81,4.81,0,0,1-1.995-.56L46.84,100.635A5.427,5.427,0,0,1,44.395,96.4V72.9a5.409,5.409,0,0,1,2.445-4.238l1.774-1.026a5.32,5.32,0,0,1,5.324,0L76.374,80.588a5.424,5.424,0,0,1,2.447,4.238",
    transform: "translate(12.476 18.806)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276028",
    "data-name": "Path 276028",
    d: "M48.3,67.633l-1.778,1.027c-1.348.776-1.348,2.047,0,2.825L69.174,84.562A5.427,5.427,0,0,1,71.62,88.8v23.5c0,1.554,1.1,2.189,2.445,1.413l1.993-1.15a5.428,5.428,0,0,0,2.448-4.238v-23.5a5.428,5.428,0,0,0-2.448-4.238L53.624,67.633a5.319,5.319,0,0,0-5.32,0",
    transform: "translate(12.791 18.806)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276029",
    "data-name": "Path 276029",
    d: "M66.051,85.4v23.5c0,1.554,1.1,2.191,2.447,1.413l1.992-1.15a5.425,5.425,0,0,0,2.447-4.238v-23.5a5.011,5.011,0,0,0-.719-2.411L65.332,82.99a5.006,5.006,0,0,1,.719,2.41",
    transform: "translate(18.36 22.205)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276030",
    "data-name": "Path 276030",
    d: "M77.246,108.169a5.822,5.822,0,0,1-.894,1.346,10.682,10.682,0,0,1-2.3,1.609c-8.606,4.972-14.811,8.539-23.418,13.508a2.7,2.7,0,0,1-2.447,0l-7.956-4.6-15.917-9.187a4.6,4.6,0,0,1,0-8.126l9.03-5.215,6.887-3.971,7.482-4.309a5.438,5.438,0,0,1,4.893,0L75.252,102.31a5.249,5.249,0,0,1,2.447,4.062,4.321,4.321,0,0,1-.452,1.8",
    transform: "translate(6.145 24.912)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276031",
    "data-name": "Path 276031",
    d: "M44.594,115.909,70.433,101c.676-.389,1.223-.073,1.223.707v2.475a2.7,2.7,0,0,1-1.223,2.119L44.591,121.209c-.675.389-1.222.073-1.222-.707v-2.474a2.7,2.7,0,0,1,1.223-2.119",
    transform: "translate(12.188 28.336)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276032",
    "data-name": "Path 276032",
    d: "M47.711,79.77l-23.4,13.494A5.406,5.406,0,0,0,21.869,97.5v4.951a5.409,5.409,0,0,0,2.447,4.238l22.648,13.075a5.408,5.408,0,0,0,4.894,0l23.4-13.493a5.409,5.409,0,0,0,2.447-4.238V97.085a5.407,5.407,0,0,0-2.447-4.238L52.6,79.77a5.408,5.408,0,0,0-4.894,0",
    transform: "translate(6.146 22.253)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276033",
    "data-name": "Path 276033",
    d: "M49.412,106.624V117.23a4.985,4.985,0,0,1-2.447-.588L24.315,103.568a5.409,5.409,0,0,1-2.447-4.238V94.38a5.479,5.479,0,0,1,2.2-4.08c-1.1.787-1.012,1.938.249,2.667l22.651,13.075a5.01,5.01,0,0,0,2.447.582",
    transform: "translate(6.145 25.376)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276034",
    "data-name": "Path 276034",
    d: "M51.542,109.166l23.4-13.494c1.351-.78,1.351-2.045,0-2.825L52.289,79.77a5.408,5.408,0,0,0-4.894,0L24,93.265c-1.351.78-1.351,2.046,0,2.826l22.648,13.075a5.408,5.408,0,0,0,4.894,0",
    transform: "translate(6.46 22.253)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276035",
    "data-name": "Path 276035",
    d: "M61.208,116.723c-.309-4.156,2.524-14.9,2.524-14.9L56.049,97.3s-.352,2.625-.789,6.151a15.565,15.565,0,0,1-1.214,4.967s-1.427,1.819-1.382,3.012,1.091,3.917,1.719,6.018a20.458,20.458,0,0,0,2.3,5.738c1.231,1.96,6.734,3.5,6.426,1.436-.429-2.862-1.553-4.514-1.9-7.9",
    transform: "translate(14.799 27.344)",
    fill: "#fdac45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276036",
    "data-name": "Path 276036",
    d: "M54.291,105.981c-.455-.023-.968.763-1.345,1.339s-1.312,1.008-1.136,2.452,1.476,2.52,1.715,4.491.338,5.362,3.241,7.736,5.94,2.58,7.049,1.924a1.425,1.425,0,0,0,.674-.867,1.144,1.144,0,0,0-.181-.917c-.338-.729-.655-1.468-.939-2.22a31.079,31.079,0,0,1-1.472-4.724c-.208-1.045-.251-2.01-.516-2.176a4.146,4.146,0,0,0-2.153-.678,4.38,4.38,0,0,0-1.937-.009c-.231.137-.163.464-.183.711-.027.333-.055.666-.082,1a.55.55,0,0,1-.05.223.189.189,0,0,1-.187.105c-.082-.017-.131-.1-.167-.176a19.409,19.409,0,0,1-1.043-3.625,12.6,12.6,0,0,0-.772-2.173c-.2-.455-.5-1.091-.638-1.5a.91.91,0,0,1-.022-.664Z",
    transform: "translate(14.554 29.783)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276037",
    "data-name": "Path 276037",
    d: "M65.638,113.031a76.247,76.247,0,0,0,3.739,7.814,24.79,24.79,0,0,0,5.078,5.911c.462.378,1.483,1.052,1.86,1.357a.706.706,0,0,1,.114,1.085c-.655.888-3.956,1.647-6.067.573s-4.407-3.418-5.717-4.35c-.655-.466-1.272-.913-1.726-1.244-.436-.318-.412-.518-.365-1.054l-.222-.857c-.346-1.765-3-5.63-3-5.63Z",
    transform: "translate(16.674 31.764)",
    fill: "#fdac45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276038",
    "data-name": "Path 276038",
    d: "M61.78,120.239c-.387.238-.365,1.179-.35,1.865s-.509,1.574.455,2.665,2.644,1.239,3.958,2.727,3.319,4.225,7.056,4.536,6.355-1.243,6.9-2.412a1.436,1.436,0,0,0,.064-1.1c-.131-.37-.339-.457-.67-.653q-1.038-.611-2.032-1.3a31.163,31.163,0,0,1-3.89-3.057c-.763-.744-1.348-1.514-1.659-1.5a4.151,4.151,0,0,0-2.159.662,4.384,4.384,0,0,0-1.6,1.091c-.113.243.128.474.251.689l.5.87a.548.548,0,0,1,.085.211.188.188,0,0,1-.095.193.276.276,0,0,1-.236-.05,19.45,19.45,0,0,1-2.914-2.4,10.5,10.5,0,0,0-1.669-1.281c-.419-.263-.958-.533-1.378-.8-.314-.2-.427-.277-.474-.427Z",
    transform: "translate(17.227 33.79)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276039",
    "data-name": "Path 276039",
    d: "M71.157,112.972c.343-2.882.862-7.292,1.17-10.233.491-4.694.731-9.571-.209-11.618-.89-1.938-5.147-4.293-9.626-6.7s-12.4-6.127-12.4-6.127L27.409,83.054c.728,3.946,1.041,5.881,3.217,9.323,2.106,3.331,4.918,5.374,10.344,7.849,4.869,2.22,10.624,4.577,11.9,5.141,1.615.714,3.117,1.25,3.972,3.664A42.319,42.319,0,0,0,62,120.087c3.662,5.408,6.924,10.219,6.924,10.219s5.434.314,8.124-4.092c0,0-2.831-6.424-5.889-13.242",
    transform: "translate(7.702 22.004)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87607",
    "data-name": "Group 87607",
    transform: "translate(35.111 100.303)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87606",
    "data-name": "Group 87606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87605",
    "data-name": "Group 87605",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276040",
    "data-name": "Path 276040",
    d: "M71.157,112.972c.343-2.882.862-7.292,1.17-10.233.491-4.694.731-9.571-.209-11.618-.89-1.938-5.147-4.293-9.626-6.7s-12.4-6.127-12.4-6.127L27.409,83.054c.728,3.946,1.041,5.881,3.217,9.323,2.106,3.331,4.918,5.374,10.344,7.849,4.869,2.22,10.624,4.577,11.9,5.141,1.615.714,3.117,1.25,3.972,3.664A42.319,42.319,0,0,0,62,120.087c3.662,5.408,6.924,10.219,6.924,10.219s5.434.314,8.124-4.092c0,0-2.831-6.424-5.889-13.242",
    transform: "translate(-27.409 -78.299)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87610",
    "data-name": "Group 87610",
    transform: "translate(56.091 104.418)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87609",
    "data-name": "Group 87609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87608",
    "data-name": "Group 87608",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276041",
    "data-name": "Path 276041",
    d: "M65.832,110.46c-2.875-6.391-5.766-12.71-6.554-14.052-1.679-2.848-15.062-10.3-15.484-10.531l-.008-.005.553-.9A8.669,8.669,0,0,0,45.4,81.512a9.229,9.229,0,0,1-.346,3.874c2.06,1.2,7.3,4.238,9.4,5.54,2.644,1.638,5.469,3.639,6.763,6.647.956,2.232,3.41,9.349,4.614,12.887",
    transform: "translate(-43.786 -81.512)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276042",
    "data-name": "Path 276042",
    d: "M58.6,118.188l1.337,2.217s6.517.624,8.524-4.2l-1.007-2.212c-.931,2.717-5.658,4.7-8.854,4.2",
    transform: "translate(16.467 32.033)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276043",
    "data-name": "Path 276043",
    d: "M36.471,58.19c5.093-.468,6.346,1.6,7.581,3.639,2.092,3.457,6,14.472,6,14.472L64.843,83l-2.584,4.808s-13.876-4.077-15.8-4.938a4.729,4.729,0,0,1-2.741-2.518C41.95,77.135,39.136,71,39.136,71Z",
    transform: "translate(10.249 16.334)",
    fill: "#fdac45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276044",
    "data-name": "Path 276044",
    d: "M36.488,58.125A8.212,8.212,0,0,1,41.777,59c1.572.988,2.207,2.173,4.075,5.943a119.313,119.313,0,0,1,4.37,11.3l3.037,1.5c-1.28.543-3.578,4.63-3.054,6.441,0,0-3.34-1.058-4.573-1.439s-1.545-1.223-2.547-3.059-4.2-8.811-4.2-8.811-2.987-12.517-2.4-12.746",
    transform: "translate(10.232 16.305)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87613",
    "data-name": "Group 87613",
    transform: "translate(46.644 74.327)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87612",
    "data-name": "Group 87612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87611",
    "data-name": "Group 87611",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276045",
    "data-name": "Path 276045",
    d: "M36.488,58.125A8.212,8.212,0,0,1,41.777,59c1.572.988,2.207,2.173,4.075,5.943a119.313,119.313,0,0,1,4.37,11.3l3.037,1.5c-1.28.543-3.578,4.63-3.054,6.441,0,0-3.34-1.058-4.573-1.439s-1.545-1.223-2.547-3.059-4.2-8.811-4.2-8.811-2.987-12.517-2.4-12.746",
    transform: "translate(-36.411 -58.022)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87616",
    "data-name": "Group 87616",
    transform: "translate(56.493 91.885)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87615",
    "data-name": "Group 87615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87614",
    "data-name": "Group 87614",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276046",
    "data-name": "Path 276046",
    d: "M48.061,72.39A6.808,6.808,0,0,0,44.1,73.571a4.836,4.836,0,0,1,3.737-1.843Z",
    transform: "translate(-44.1 -71.728)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276047",
    "data-name": "Path 276047",
    d: "M30.463,59.968l-5.214,1.993c-1.03.473.835,6.65,1.294,13.893.47,7.439,1.886,16.8,1.886,16.8s5.777,1.595,14.084-2.006c7.349-3.187,8.27-6.678,8.27-6.678l-2.308-3.222-.811-6.788a7.972,7.972,0,0,0,.433-7.971C45.884,61.828,39.71,58.1,39.71,58.1l-2.743.424Z",
    transform: "translate(7.01 16.328)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87619",
    "data-name": "Group 87619",
    transform: "translate(31.953 74.43)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87618",
    "data-name": "Group 87618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87617",
    "data-name": "Group 87617",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276048",
    "data-name": "Path 276048",
    d: "M30.463,59.968l-5.214,1.993c-1.03.473.835,6.65,1.294,13.893.47,7.439,1.886,16.8,1.886,16.8s5.777,1.595,14.084-2.006c7.349-3.187,8.27-6.678,8.27-6.678l-2.308-3.222-.811-6.788a7.972,7.972,0,0,0,.433-7.971C45.884,61.828,39.71,58.1,39.71,58.1l-2.743.424Z",
    transform: "translate(-24.944 -58.103)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87622",
    "data-name": "Group 87622",
    transform: "translate(39.458 91.163)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87621",
    "data-name": "Group 87621"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87620",
    "data-name": "Group 87620",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276049",
    "data-name": "Path 276049",
    d: "M30.8,72.487a6.011,6.011,0,0,0,5.529,2.039,5.933,5.933,0,0,0,4.426-3.363A4.9,4.9,0,0,1,36.09,75.49c-4.434.55-5.288-3-5.288-3",
    transform: "translate(-30.802 -71.164)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276050",
    "data-name": "Path 276050",
    d: "M40.847,44.323c1.177.653,2.689,3.529,2.714,9.644.02,5.182-1.623,6.506-2.456,6.9s-2.465.211-4.052-.009L37.082,63a26.469,26.469,0,0,1,3.8,8.4,69.444,69.444,0,0,0-10.656-6.991l-.154-7.183s-.906.929-2.52-.407c-1.334-1.1-1.824-3.01-.838-4.067a2.268,2.268,0,0,1,3.628.62s-.717-6.23,2.589-8.164,7.75,1.125,7.918-.889",
    transform: "translate(7.36 12.456)",
    fill: "#fdac45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276051",
    "data-name": "Path 276051",
    d: "M34.758,54.27l1.661.437a.844.844,0,0,1-1.033.641.9.9,0,0,1-.629-1.077",
    transform: "translate(9.761 15.251)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276052",
    "data-name": "Path 276052",
    d: "M39.335,48.628l-1.686-.407a.832.832,0,0,1,1.016-.653.911.911,0,0,1,.67,1.061",
    transform: "translate(10.58 13.361)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276053",
    "data-name": "Path 276053",
    d: "M33.08,49.576l1.492-.884a.832.832,0,0,0-1.164-.327.911.911,0,0,0-.328,1.211",
    transform: "translate(9.266 13.558)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276054",
    "data-name": "Path 276054",
    d: "M39.169,50.419a.7.7,0,1,1-.776-.658.716.716,0,0,1,.776.658",
    transform: "translate(10.612 13.983)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276055",
    "data-name": "Path 276055",
    d: "M34.911,50.872a.7.7,0,1,1-.776-.658.717.717,0,0,1,.776.658",
    transform: "translate(9.416 14.11)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276056",
    "data-name": "Path 276056",
    d: "M35.92,57.756c-1.672-.173-5.124-1.065-5.7-2.4a3.507,3.507,0,0,0,1.249,1.7c1.047.849,4.475,1.745,4.475,1.745Z",
    transform: "translate(8.494 15.555)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276057",
    "data-name": "Path 276057",
    d: "M33.469,50.581a.184.184,0,0,0-.105-.072c-.076-.029-.151-.053-.228-.077l-.3-.1c-.085-.028-.17-.055-.257-.077a1.12,1.12,0,0,0-.161-.029.562.562,0,0,0-.211.018c-.055.014-.063.086-.05.129a.183.183,0,0,0,.126.123c.041.009.081.027.123.033l.085.015.035.008.018,0q.038.008.077.019c.091.023.179.053.269.079a1.556,1.556,0,0,0,.356.079.348.348,0,0,0,.177-.031.1.1,0,0,0,.049-.124",
    transform: "translate(9.035 14.114)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276058",
    "data-name": "Path 276058",
    d: "M33.429,50.967a.365.365,0,0,0-.259-.141,2.246,2.246,0,0,0-.436-.014c-.165.009-.332.018-.5.036s-.06.254.06.265a4.03,4.03,0,0,0,.62-.024,2.323,2.323,0,0,1,.25-.008h.113a.383.383,0,0,0,.076-.01c.044-.012.04-.017.069-.045a.05.05,0,0,0,0-.059",
    transform: "translate(9.036 14.278)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276059",
    "data-name": "Path 276059",
    d: "M33.346,51.212c-.042-.04-.106-.017-.155-.006a.787.787,0,0,0-.108.029c-.073.027-.146.051-.22.076s-.138.044-.209.064l-.086.023a1.163,1.163,0,0,0-.111.041.085.085,0,0,0-.058.087v.022a.148.148,0,0,0,.074.118.209.209,0,0,0,.1.017l.029-.005c.033-.006.065-.008.1-.017l.113-.032c.073-.023.146-.046.219-.073a.753.753,0,0,0,.261-.142.224.224,0,0,0,.063-.087.113.113,0,0,0-.012-.114",
    transform: "translate(9.105 14.385)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276060",
    "data-name": "Path 276060",
    d: "M43.975,51.4a.044.044,0,0,0,0-.022c-.293-1.644-.62-2.869-.7-3.154a.564.564,0,0,0-.018-.058c-.005,3.8-4.995,3.614-4.995,3.614.935-2.494-.311-3.5-.311-3.5a5.962,5.962,0,0,1-3.769,3.812,5.316,5.316,0,0,0-.992-3.4,6.114,6.114,0,0,1-2.21,5.815,2.268,2.268,0,0,0-3.628-.62c-.986,1.058-.5,2.967.838,4.07,1.617,1.334,2.52.407,2.52.407L30.79,62.1c-.208-1.767-6.563-5.885-6.855-10.9-.284-4.9,1.412-8.122,6.629-10.288,4.641-1.93,8.954,1.289,8.954,1.289a5.4,5.4,0,0,1,5.549,4.27A5.568,5.568,0,0,1,43.975,51.4",
    transform: "translate(6.718 11.324)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276061",
    "data-name": "Path 276061",
    d: "M32.189,46.85a6.25,6.25,0,0,1-4.717,4.58,2.441,2.441,0,0,1,2.507,1.235S33,51.489,32.189,46.85",
    transform: "translate(7.72 13.166)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276062",
    "data-name": "Path 276062",
    d: "M43.324,48.436c-.108,0-.22,0-.336.006a9.931,9.931,0,0,0-3.337.582c-1.054.483-1.418.908-2.009.994-.63.087-1.043-.229-2.191-.4a11.141,11.141,0,0,0-3.574.395q-.186.046-.357.092a.659.659,0,0,0-.377.664,1.215,1.215,0,0,0,.366.658.8.8,0,0,1,.127.269,11.737,11.737,0,0,0,.5,1.889,2.139,2.139,0,0,0,.48.637,1.723,1.723,0,0,0,.241.174c.045.026.09.05.137.073a1.854,1.854,0,0,0,.407.14l.068.013.108.018.113.012a2.488,2.488,0,0,0,.356.008c.049,0,.1-.005.152-.009s.124-.013.19-.022a2.766,2.766,0,0,0,2.393-1.795c.341-.789.211-1.822.886-1.915a.606.606,0,0,1,.065-.005.468.468,0,0,1,.06,0c.5.05.474,1.016.812,1.663a2.5,2.5,0,0,0,.5.687c.038.035.077.068.118.1.02.017.042.032.063.046s.044.029.067.044.038.026.059.037l.065.036c.017.009.033.017.051.024a.312.312,0,0,0,.036.018,1.908,1.908,0,0,0,.592.158.365.365,0,0,0,.054.005,2.957,2.957,0,0,0,.717-.027,2.362,2.362,0,0,0,2.024-1.646,13.668,13.668,0,0,0,.354-2.011.69.69,0,0,1,.115-.274,1.5,1.5,0,0,0,.286-.762c.006-.315-.2-.573-.389-.573m-6.942,3.753a2.51,2.51,0,0,1-.474,1.1h0a2.272,2.272,0,0,1-1.578.812,1.6,1.6,0,0,1-1.562-.534c-.019-.023-.036-.045-.051-.067a.727.727,0,0,1-.047-.068c-.014-.021-.028-.041-.041-.063l-.033-.058c-.009-.015-.017-.031-.024-.046a.331.331,0,0,1-.022-.042c-.012-.023-.023-.046-.033-.069h0c-.032-.069-.06-.138-.083-.2l0-.005c-.014-.042-.028-.085-.042-.124-.023-.073-.041-.141-.056-.2,0-.013-.008-.026-.01-.038l-.01-.037c-.131-.5-.3-1.5-.055-1.761a3.036,3.036,0,0,1,2-.641,1.147,1.147,0,0,1,.117-.005,4.1,4.1,0,0,1,.5.018c.065.005.131.013.195.02a4.336,4.336,0,0,1,.491.094c.053.014.1.028.151.044s.113.036.164.055a.255.255,0,0,0,.033.013c.02.008.04.017.059.026a.888.888,0,0,1,.337.225,2.357,2.357,0,0,1,.082,1.558m6.359-1.117a2.534,2.534,0,0,1-.975,1.8,2.038,2.038,0,0,1-.806.3,1.6,1.6,0,0,1-1.659-.544l0-.008c-.012-.014-.022-.028-.032-.042s-.024-.035-.035-.051l-.018-.026c-.015-.026-.031-.051-.045-.077s-.031-.058-.046-.088l-.022-.044-.01-.026-.017-.037-.012-.028a2.382,2.382,0,0,1-.118-.37,2.56,2.56,0,0,1-.019-1.567,3.367,3.367,0,0,1,1.76-1.016,4.631,4.631,0,0,1,.5-.109l.059-.009.064-.009c.06-.009.118-.014.174-.021l.064-.005.082,0c.046,0,.092,0,.137,0a2.255,2.255,0,0,1,.252.01l.06.006.015,0,.041.005.061.009c.024,0,.05.01.073.015a.966.966,0,0,1,.12.032l.021.006a.846.846,0,0,1,.275.137c.242.195.145,1.23.055,1.761",
    transform: "translate(8.752 13.612)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276063",
    "data-name": "Path 276063",
    d: "M32.142,49.954l-3.163,1.139a3.124,3.124,0,0,1,.578.7l2.629-.848Z",
    transform: "translate(8.144 14.038)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276064",
    "data-name": "Path 276064",
    d: "M36.034,50.479l.551,4.062,2.37-.9-2.694-3.265a.53.53,0,0,0-.227.1",
    transform: "translate(10.126 14.157)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276065",
    "data-name": "Path 276065",
    d: "M47.074,83.326l1.772,2.162a.085.085,0,0,1-.085.137l-2.738-.642Z",
    transform: "translate(12.934 23.416)",
    fill: "#fdac45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276066",
    "data-name": "Path 276066",
    d: "M48.289,85.243a.085.085,0,0,0,.085-.137l-.346-.421a.47.47,0,0,1-.281.4l-.044.019Z",
    transform: "translate(13.406 23.798)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276067",
    "data-name": "Path 276067",
    d: "M38.209,80.118l.22.137.264.165,9.527,5.931a1.249,1.249,0,0,0,.765-.5,1.281,1.281,0,0,0,.286-1.158l-9.522-5.927-.506-.315c.316.223-.714,1.884-1.034,1.665",
    transform: "translate(10.738 22.047)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276068",
    "data-name": "Path 276068",
    d: "M38.86,80.528l.491.3c.14.092.42-.154.669-.484.332-.438.544-1.063.36-1.188l-.361-.224-.131-.079c.184.124-.028.751-.36,1.188-.24.316-.509.556-.651.491h0l-.014-.008",
    transform: "translate(10.92 22.161)",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276069",
    "data-name": "Path 276069",
    d: "M39.064,80.654c.323.216,1.35-1.454,1.027-1.67l-.491-.306c.323.216-.7,1.887-1.027,1.67Z",
    transform: "translate(10.84 22.11)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276070",
    "data-name": "Path 276070",
    d: "M38.209,80.118l.484.3c.316.215,1.321-1.387,1.056-1.653l-.017-.014-.489-.3c.316.223-.714,1.884-1.034,1.665",
    transform: "translate(10.738 22.047)",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87625",
    "data-name": "Group 87625",
    transform: "translate(48.946 101.348)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87624",
    "data-name": "Group 87624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87623",
    "data-name": "Group 87623",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276071",
    "data-name": "Path 276071",
    d: "M51.045,86.776l0-.1-1.9-1.239L39.065,79.162c.019-.031.013-.046-.012-.047-.264.474-.665.94-.844.817l.219.137.265.167,9.527,5.931,2.738.64a.081.081,0,0,0,.087-.032",
    transform: "translate(-38.208 -79.115)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276072",
    "data-name": "Path 276072",
    d: "M36.641,79.129,38.7,80.412c.137.095.415-.149.664-.475.333-.437.551-1.063.369-1.19h0l-2.062-1.286c-.412-.255-1.031.515-1.168,1.12a.5.5,0,0,0,.143.551",
    transform: "translate(10.25 21.753)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87628",
    "data-name": "Group 87628",
    transform: "translate(46.724 99.163)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87627",
    "data-name": "Group 87627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87626",
    "data-name": "Group 87626",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276073",
    "data-name": "Path 276073",
    d: "M37.275,78.931a1.519,1.519,0,0,0,.509-1.246.342.342,0,0,0-.187-.257c-.407-.14-.968.58-1.1,1.152a.507.507,0,0,0,.135.543c.156.095.4.033.643-.191",
    transform: "translate(-36.474 -77.409)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276074",
    "data-name": "Path 276074",
    d: "M41.877,80.248a1.912,1.912,0,0,1,1.659.374c.538.337,1.323.392,1.386.661s-.314.665-.314.665Z",
    transform: "translate(11.768 22.534)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276075",
    "data-name": "Path 276075",
    d: "M37.554,88.381c1.147-.106,4.854-.19,6.063-.453A4.958,4.958,0,0,0,46.348,86.4c.176-.2.334-.418.5-.624a1.577,1.577,0,0,1,.455-.452c.151-.081.314-.14.461-.227a1.347,1.347,0,0,0,.641-1.011,1.639,1.639,0,0,1,.028-.25.313.313,0,0,1,.137-.2.443.443,0,0,1,.259-.026,3.832,3.832,0,0,0,.974.051,1.824,1.824,0,0,0,.689-.232c.158-.1.446-.4.183-.553-.351-.211-.693-.439-.971-.57a11.544,11.544,0,0,0-4.3-.963c-.744-.065-1.784-.064-2.526-.114-.319-.021-.656-.085-.989-.123l-.484-.3a2.088,2.088,0,0,0-.871.307c-.425.25-.9.653-1.33.885-1.1.588-3.115.61-4.706.55",
    transform: "translate(9.695 22.707)",
    fill: "#fdac45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276076",
    "data-name": "Path 276076",
    d: "M61.165,72.121l-12.12,5.762L45.883,92.049,46.916,93.1l11.4-5.8L62.2,73.176Z",
    transform: "translate(12.894 20.268)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276077",
    "data-name": "Path 276077",
    d: "M50.078,77.674,46.916,91.839l-1.033-1.054L49.045,76.62Z",
    transform: "translate(12.894 21.532)",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276078",
    "data-name": "Path 276078",
    d: "M62.171,72.719,49.785,78.611l-3.267,14.51.323.342,11.675-5.925,3.976-14.478Z",
    transform: "translate(13.073 20.435)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87631",
    "data-name": "Group 87631",
    transform: "translate(59.591 93.154)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87630",
    "data-name": "Group 87630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87629",
    "data-name": "Group 87629",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276079",
    "data-name": "Path 276079",
    d: "M62.171,72.719,49.785,78.611l-3.267,14.51.323.342,11.675-5.925,3.976-14.478Z",
    transform: "translate(-46.519 -72.719)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276080",
    "data-name": "Path 276080",
    d: "M50.107,77.661,46.84,92.171l-.322-.342,3.267-14.51Z",
    transform: "translate(13.073 21.728)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87634",
    "data-name": "Group 87634",
    transform: "translate(59.591 99.047)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87633",
    "data-name": "Group 87633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87632",
    "data-name": "Group 87632",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276081",
    "data-name": "Path 276081",
    d: "M50.107,77.661,46.84,92.171l-.322-.342,3.267-14.51Z",
    transform: "translate(-46.518 -77.318)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276082",
    "data-name": "Path 276082",
    d: "M62.422,72.986,50.036,78.879l-3.267,14.51,11.676-5.926Z",
    transform: "translate(13.143 20.511)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87637",
    "data-name": "Group 87637",
    transform: "translate(69.267 104.457)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87636",
    "data-name": "Group 87636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87635",
    "data-name": "Group 87635",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276083",
    "data-name": "Path 276083",
    d: "M54.072,81.589a3.348,3.348,0,0,0,3,1l.286-1.048Z",
    transform: "translate(-54.072 -81.542)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87640",
    "data-name": "Group 87640",
    transform: "translate(63.687 99.566)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87639",
    "data-name": "Group 87639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87638",
    "data-name": "Group 87638",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276084",
    "data-name": "Path 276084",
    d: "M49.732,78.213c-.053.188.024.286.169.216a.8.8,0,0,0,.357-.468c.053-.188-.023-.286-.169-.216a.813.813,0,0,0-.357.468",
    transform: "translate(-49.716 -77.724)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276085",
    "data-name": "Path 276085",
    d: "M50.212,75.662a.909.909,0,0,0-.879-.325.977.977,0,0,0-.607.8,2.367,2.367,0,0,0-.046.653l.242-.117a2.264,2.264,0,0,1,.046-.483.754.754,0,0,1,.434-.614.669.669,0,0,1,.63.261,2.756,2.756,0,0,1,.624,2.271,1.241,1.241,0,0,1-.117.329.558.558,0,0,1-.315.284.349.349,0,0,1-.132.014.531.531,0,0,0-.067.155c-.006.029-.013.056-.017.083a.555.555,0,0,0,.1.01.71.71,0,0,0,.179-.023.947.947,0,0,0,.123-.05,1.068,1.068,0,0,0,.484-.749,3.042,3.042,0,0,0-.687-2.5",
    transform: "translate(13.679 21.164)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87643",
    "data-name": "Group 87643",
    transform: "translate(65.389 98.755)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87642",
    "data-name": "Group 87642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87641",
    "data-name": "Group 87641",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276086",
    "data-name": "Path 276086",
    d: "M51.061,77.58c-.051.188.024.286.169.216a.8.8,0,0,0,.357-.468c.053-.188-.023-.286-.169-.216a.813.813,0,0,0-.357.468",
    transform: "translate(-51.044 -77.091)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276087",
    "data-name": "Path 276087",
    d: "M51.54,75.029a.909.909,0,0,0-.879-.325.977.977,0,0,0-.607.8,2.367,2.367,0,0,0-.046.653l.242-.117a2.264,2.264,0,0,1,.046-.483.751.751,0,0,1,.434-.614.669.669,0,0,1,.63.261,2.756,2.756,0,0,1,.624,2.271,1.24,1.24,0,0,1-.117.329.558.558,0,0,1-.315.284.349.349,0,0,1-.132.014.53.53,0,0,0-.067.155c-.006.029-.013.056-.017.083a.556.556,0,0,0,.1.01.718.718,0,0,0,.179-.023.95.95,0,0,0,.123-.05,1.068,1.068,0,0,0,.484-.749,3.042,3.042,0,0,0-.687-2.5",
    transform: "translate(14.052 20.986)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87646",
    "data-name": "Group 87646",
    transform: "translate(67.091 97.945)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87645",
    "data-name": "Group 87645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87644",
    "data-name": "Group 87644",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276088",
    "data-name": "Path 276088",
    d: "M52.39,76.948c-.053.188.024.286.169.216a.8.8,0,0,0,.357-.468c.053-.188-.023-.286-.169-.216a.808.808,0,0,0-.357.468",
    transform: "translate(-52.373 -76.458)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276089",
    "data-name": "Path 276089",
    d: "M52.869,74.4a.909.909,0,0,0-.879-.325.977.977,0,0,0-.607.8,2.366,2.366,0,0,0-.046.653l.242-.117a2.272,2.272,0,0,1,.046-.483.754.754,0,0,1,.434-.614.669.669,0,0,1,.63.261,2.756,2.756,0,0,1,.624,2.271,1.24,1.24,0,0,1-.117.329.558.558,0,0,1-.315.284.349.349,0,0,1-.132.014.53.53,0,0,0-.067.155c-.006.029-.013.056-.017.083a.555.555,0,0,0,.1.01.657.657,0,0,0,.179-.023.95.95,0,0,0,.123-.05,1.068,1.068,0,0,0,.484-.749,3.042,3.042,0,0,0-.687-2.5",
    transform: "translate(14.425 20.808)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87649",
    "data-name": "Group 87649",
    transform: "translate(68.793 97.134)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87648",
    "data-name": "Group 87648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87647",
    "data-name": "Group 87647",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276090",
    "data-name": "Path 276090",
    d: "M53.719,76.315c-.053.188.024.286.169.216a.8.8,0,0,0,.357-.468c.053-.188-.023-.286-.169-.216a.808.808,0,0,0-.357.468",
    transform: "translate(-53.702 -75.826)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276091",
    "data-name": "Path 276091",
    d: "M54.2,73.763a.909.909,0,0,0-.879-.325.976.976,0,0,0-.607.8,2.366,2.366,0,0,0-.046.653l.242-.117a2.272,2.272,0,0,1,.046-.483.754.754,0,0,1,.434-.614.669.669,0,0,1,.63.261,2.756,2.756,0,0,1,.624,2.271,1.241,1.241,0,0,1-.117.329.558.558,0,0,1-.315.284.349.349,0,0,1-.132.014.531.531,0,0,0-.067.155c-.006.029-.013.056-.017.083a.557.557,0,0,0,.1.01.657.657,0,0,0,.179-.023.953.953,0,0,0,.123-.05,1.068,1.068,0,0,0,.484-.749,3.042,3.042,0,0,0-.687-2.5",
    transform: "translate(14.799 20.631)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87652",
    "data-name": "Group 87652",
    transform: "translate(70.495 96.324)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87651",
    "data-name": "Group 87651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87650",
    "data-name": "Group 87650",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276092",
    "data-name": "Path 276092",
    d: "M55.047,75.682c-.051.188.024.286.169.216a.8.8,0,0,0,.357-.468c.053-.188-.023-.286-.169-.216a.813.813,0,0,0-.357.468",
    transform: "translate(-55.03 -75.193)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276093",
    "data-name": "Path 276093",
    d: "M55.526,73.131a.909.909,0,0,0-.879-.325.977.977,0,0,0-.607.8,2.366,2.366,0,0,0-.046.653l.242-.117a2.264,2.264,0,0,1,.046-.483.754.754,0,0,1,.434-.614.669.669,0,0,1,.63.261,2.756,2.756,0,0,1,.624,2.271,1.241,1.241,0,0,1-.117.329.558.558,0,0,1-.315.284.349.349,0,0,1-.132.014.53.53,0,0,0-.067.155c-.006.029-.013.056-.017.083a.557.557,0,0,0,.1.01.71.71,0,0,0,.179-.023.948.948,0,0,0,.123-.05,1.068,1.068,0,0,0,.484-.749,3.042,3.042,0,0,0-.687-2.5",
    transform: "translate(15.172 20.453)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87655",
    "data-name": "Group 87655",
    transform: "translate(72.197 95.513)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87654",
    "data-name": "Group 87654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87653",
    "data-name": "Group 87653",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276094",
    "data-name": "Path 276094",
    d: "M56.376,75.049c-.051.19.024.287.169.218A.8.8,0,0,0,56.9,74.8c.053-.187-.023-.286-.169-.216a.821.821,0,0,0-.357.468",
    transform: "translate(-56.359 -74.56)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276095",
    "data-name": "Path 276095",
    d: "M56.855,72.5a.909.909,0,0,0-.879-.325.977.977,0,0,0-.607.8,2.367,2.367,0,0,0-.046.653l.242-.117a2.264,2.264,0,0,1,.046-.483.751.751,0,0,1,.434-.614.669.669,0,0,1,.63.261,2.756,2.756,0,0,1,.624,2.271,1.241,1.241,0,0,1-.117.329.558.558,0,0,1-.315.284.349.349,0,0,1-.132.014.53.53,0,0,0-.067.155c-.006.029-.013.056-.017.083a.557.557,0,0,0,.1.01.718.718,0,0,0,.179-.023.951.951,0,0,0,.123-.05A1.068,1.068,0,0,0,57.542,75a3.042,3.042,0,0,0-.687-2.5",
    transform: "translate(15.546 20.275)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87658",
    "data-name": "Group 87658",
    transform: "translate(73.899 94.703)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87657",
    "data-name": "Group 87657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87656",
    "data-name": "Group 87656",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276096",
    "data-name": "Path 276096",
    d: "M57.7,74.417c-.053.188.024.286.169.216a.8.8,0,0,0,.357-.468c.053-.188-.023-.286-.169-.216a.808.808,0,0,0-.357.468",
    transform: "translate(-57.688 -73.928)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276097",
    "data-name": "Path 276097",
    d: "M58.184,71.865a.909.909,0,0,0-.879-.325.977.977,0,0,0-.607.8,2.366,2.366,0,0,0-.046.653l.242-.115a2.268,2.268,0,0,1,.046-.484.754.754,0,0,1,.434-.614.669.669,0,0,1,.63.261,2.756,2.756,0,0,1,.624,2.271,1.241,1.241,0,0,1-.117.329.558.558,0,0,1-.315.284.349.349,0,0,1-.132.014.53.53,0,0,0-.067.155c-.006.031-.013.056-.017.083a.557.557,0,0,0,.1.01.71.71,0,0,0,.179-.023.951.951,0,0,0,.123-.05,1.068,1.068,0,0,0,.484-.749,3.042,3.042,0,0,0-.687-2.5",
    transform: "translate(15.919 20.097)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276098",
    "data-name": "Path 276098",
    d: "M59.893,75.285s-.542,1.988-.682,2.493c-.333,1.207-2.638,1.654-3.887,1.81-2.39.3-2.662.816-2.087,2.513.53,1.565,2.087,2.155,4.244,1.9a3.906,3.906,0,0,0,2.958-2.584c.7-2,.323-4.135.6-5.3s-.539-1.528-1.148-.831",
    transform: "translate(14.889 21.057)",
    fill: "#fdac45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276099",
    "data-name": "Path 276099",
    d: "M44.047,132.655v-23.5a5.425,5.425,0,0,0-2.447-4.238L18.923,91.825a1.61,1.61,0,0,1,0-2.79l.552-.319-1.922-11.6a6.5,6.5,0,0,0-2.82-4.212l-1.992-1.15c-1.346-.778-2.447-.141-2.447,1.412V83.485l.04,29.75a5.427,5.427,0,0,0,2.447,4.238l28.819,16.6c1.346.776,2.447.141,2.447-1.413",
    transform: "translate(2.893 20.07)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276100",
    "data-name": "Path 276100",
    d: "M49.215,101.7V125.2c0,.05,0,.106-.005.158a5.465,5.465,0,0,1-2.419,4.069.039.039,0,0,0-.023.012l-1.988,1.146a1,1,0,0,1-.187.1.936.936,0,0,1-.1.051c-.012.005-.023.005-.028.01a1.663,1.663,0,0,1-.2.074,5.676,5.676,0,0,1-3.6.1,3.478,3.478,0,0,1-.424-.158c1.175.485,2.084-.175,2.091-1.582V105.675a5.424,5.424,0,0,0-2.447-4.238l-4.441-2.565L17.2,88.345a1.611,1.611,0,0,1,0-2.79l2.025-1.17a5.44,5.44,0,0,1,4.893,0L42.333,94.9l4.435,2.559a5.421,5.421,0,0,1,2.447,4.238",
    transform: "translate(4.608 23.551)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276101",
    "data-name": "Path 276101",
    d: "M37.1,102.278v23.505c-.005,1.407-.915,2.068-2.091,1.582a3.477,3.477,0,0,0,.424.158,5.684,5.684,0,0,0,3.6-.1,1.918,1.918,0,0,0,.2-.074c.005-.005.017-.005.028-.01.033-.018.068-.029.1-.051a1,1,0,0,0,.187-.1l1.988-1.148a.051.051,0,0,1,.023-.01,5.465,5.465,0,0,0,2.419-4.069c.005-.051.005-.108.005-.159V98.3a5.012,5.012,0,0,0-.716-2.408l-6.884,3.975a5.011,5.011,0,0,1,.719,2.411",
    transform: "translate(9.839 26.948)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276102",
    "data-name": "Path 276102",
    d: "M38.623,88.076c-3.133-.119-10.267-1.106-10.267-1.106L29.94,73.09c.8-3.295-1.468-10.864-3.255-11.974-.793.236-2.421.7-4.221,3.427-.98,1.485-1.209,4.028-1.891,10.167-.484,4.368-.675,10.353-.738,14.31-.07,4.4,1.718,5.608,5.694,5.845,6.651.395,13.539-.712,16.146-.953",
    transform: "translate(5.574 17.175)",
    fill: "#fdac45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276103",
    "data-name": "Path 276103",
    d: "M27.17,60.979a6.6,6.6,0,0,0-4.89,3.6C21.007,66.694,20.5,73.1,19.923,79.916a76.125,76.125,0,0,0-.3,11.934c.11,1.138,1.107,2.88,3.93,3.117a40.734,40.734,0,0,0,5.657.02s-.543-4.942,1.546-7.675L28.6,86.918l2.01-15.166s-.173-7.832-3.442-10.773",
    transform: "translate(5.483 17.136)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87661",
    "data-name": "Group 87661",
    transform: "translate(24.996 78.116)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87660",
    "data-name": "Group 87660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87659",
    "data-name": "Group 87659",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276104",
    "data-name": "Path 276104",
    d: "M27.17,60.979a6.6,6.6,0,0,0-4.89,3.6C21.007,66.694,20.5,73.1,19.923,79.916a76.125,76.125,0,0,0-.3,11.934c.11,1.138,1.107,2.88,3.93,3.117a40.734,40.734,0,0,0,5.657.02s-.543-4.942,1.546-7.675L28.6,86.918l2.01-15.166s-.173-7.832-3.442-10.773",
    transform: "translate(-19.513 -60.979)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87664",
    "data-name": "Group 87664",
    transform: "translate(29.334 103.013)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87663",
    "data-name": "Group 87663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87662",
    "data-name": "Group 87662",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276105",
    "data-name": "Path 276105",
    d: "M27.65,81.456a9.135,9.135,0,0,0-4.751.934s1.015-1.647,4.89-1.975Z",
    transform: "translate(-22.899 -80.415)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276106",
    "data-name": "Path 276106",
    d: "M34.946,44.592a1.8,1.8,0,0,0,1.346-2.729,3.923,3.923,0,0,0-1.76-1.054,2.491,2.491,0,0,1-1-.6c-.6-.78.214-1.537.806-1.941a8.75,8.75,0,0,0,2.2-1.571,2.908,2.908,0,0,0,.6-2.053c-.159-1.774-1.66-2.552-3.131-3.188-2.061-.89-4.1-1.754-5.042-3.96-1.024-2.406.275-5.456,2.4-6.793a5.6,5.6,0,0,1,7.119,1.018,7.19,7.19,0,0,1,1.463,7.521C37.768,34.225,29.2,32.81,27.807,27.9a7.7,7.7,0,0,1,2.009-7.42,7.142,7.142,0,0,1,6.2-1.787A7.032,7.032,0,0,1,41.3,23.833a12.026,12.026,0,0,1,.445,4,5.77,5.77,0,0,1-1.952,3.664,8.217,8.217,0,0,1-7.06,2.05,8.132,8.132,0,0,1-5.651-4.519c-1.591-3.687-.541-8.915,3.308-10.789,2.681-1.307,5.571-1.546,8.106.211a10.705,10.705,0,0,1,4.335,5.889,7.936,7.936,0,0,1-1.823,7.553,9.239,9.239,0,0,1-6.218,2.732,9.069,9.069,0,0,1-6.173-1.851,9.8,9.8,0,0,1-3.328-6.742A10.314,10.314,0,0,1,31.863,15.51c4.531-1.965,9.731-1.567,14.409-.332A64.768,64.768,0,0,1,60.4,21.047c2.366,1.281,4.673,2.649,7.1,3.807a66.163,66.163,0,0,0,6.713,2.773A38.924,38.924,0,0,0,87,30.072a31.6,31.6,0,0,0,12.139-2.217,20.284,20.284,0,0,0,8.908-7.01,7.85,7.85,0,0,0,1.841-4.936,2.635,2.635,0,0,0-2.843-2.754c-2.055.15-3.188,2.066-4.084,3.685l.252.058a7.913,7.913,0,0,0-2.776-3.379,3.061,3.061,0,0,0-3.315.108c-2.109,1.727-.6,5.169.671,6.9,3,4.09,8.026,6.509,12.719,8.054a41.6,41.6,0,0,0,21.037,1.674c6.03-1.211,11.519-4.015,16.888-6.909,3.183-1.717,6.345-3.513,9.672-4.941,3.579-1.537,7.676-2.74,11.533-1.5,3.258,1.047,6.331,4.473,5.406,8.106-.784,3.077-4.607,5.262-7.424,3.318-2.394-1.653-6.4-7.254-1.892-8.866,2.849-1.02,6.6.51,8.726,2.415,1.249,1.118,2.2,2.747,1.49,4.432-.688,1.633-2.621,2.371-4.279,2.443-3.551.151-7.239-2.34-7.3-6.117a5.315,5.315,0,0,1,1.929-4.313,6.637,6.637,0,0,1,4.858-1.131,11.484,11.484,0,0,1,8.591,5.435c1.541,2.855.958,7.017-2.2,8.515-2.841,1.348-6.711.746-9.528-.386a10.313,10.313,0,0,1-6.331-6.356c-.983-3.409.8-7.4,4.785-7.111,3.712.269,6.953,3.6,7.684,7.146.674,3.27-1.033,7.089-4.332,8.183-3.032,1-7.076-.872-7.148-4.357-.064-3.138,3.182-6.214,6.217-4.263a4.027,4.027,0,0,1,1.91,4.049c-.354,1.606-2.271,3.118-3.811,1.954a3.51,3.51,0,0,1-1.114-3.5,3.9,3.9,0,0,1,3.582-2.576,7.025,7.025,0,0,1,4.718,1.257,1.785,1.785,0,0,1,.722,2.44c-.8,1.176-1.992.108-2.255-.872a3.111,3.111,0,0,1,1.545-3.5c1.623-.744,3.391.682,3.632,2.306a1.611,1.611,0,0,1-.87,1.888,1.86,1.86,0,0,1-2.1-.784c-.918-1.688,1.728-3.155,3.045-2.237,1.66,1.158,1,3.633-.585,4.464A3.628,3.628,0,0,1,172.882,28a4.688,4.688,0,0,1-.853-4.578,5.178,5.178,0,0,1,3.2-2.943,5.692,5.692,0,0,1,7.52,4.979,6.783,6.783,0,0,1-5.637,6.556,8.721,8.721,0,0,1-8.671-4.722,6.079,6.079,0,0,1-.538-4.5c.615-1.9,2.6-2.606,4.457-2.376a6.183,6.183,0,0,1,5.138,7.94,8.872,8.872,0,0,1-3.016,3.929,4.738,4.738,0,0,0-1.955,3.767,2.677,2.677,0,0,0,1.984,2.314c.542.216,1.606.461,1.614,1.205s-.885,1.016-1.436,1.246c-.943.4-1.92.9-1.792,2.086a1.983,1.983,0,0,0,1.857,1.811c.354.01.158-.482-.122-.489a1.362,1.362,0,0,1-.807-2.329,11.622,11.622,0,0,1,2.065-1.048c1.118-.685.828-1.922-.234-2.481-.785-.414-1.823-.519-2.331-1.316a2.971,2.971,0,0,1,.438-3.218c1.217-1.615,3.068-2.542,3.919-4.458a6.751,6.751,0,0,0-3.541-8.925,5.654,5.654,0,0,0-5.379.247,4.356,4.356,0,0,0-1.526,4.066c.346,3.564,3.429,6.592,6.793,7.5a7.249,7.249,0,0,0,8.546-3.8,6.106,6.106,0,0,0-3.268-8.31c-3-1.249-7.138.24-7.895,3.614-.678,3.017,1.813,6.545,5.1,5.912a3.25,3.25,0,0,0,2.8-3.154,2.824,2.824,0,0,0-2.326-2.863,2.488,2.488,0,0,0-2.735,2.237,2.258,2.258,0,0,0,2.372,2.068c1.482-.037,1.9-1.536,1.547-2.772a3.565,3.565,0,0,0-3.008-2.6c-2.855-.169-4.161,4.129-1.868,5.715,1.205.834,2.5-.4,2.289-1.7-.247-1.555-2.083-2.419-3.418-2.82-2.78-.835-7.126.072-6.8,3.759a3.807,3.807,0,0,0,1.823,3.032,2.8,2.8,0,0,0,3.624-1.3c1.635-2.755-1.129-6.373-4.1-6.341-3.221.035-5.2,3.9-4.177,6.728,1.1,3.055,5.011,4.436,7.913,3.219,3.4-1.427,4.909-5.5,3.988-8.926-.943-3.507-4.15-6.681-7.84-7.074a4.813,4.813,0,0,0-4.614,1.97,6.561,6.561,0,0,0-.826,4.922c.679,3.361,3.383,5.87,6.427,7.2a15.572,15.572,0,0,0,5.01,1.245,9.708,9.708,0,0,0,5.638-.927c3.022-1.779,3.375-6.016,1.788-8.863a12.04,12.04,0,0,0-9.072-5.662,6.747,6.747,0,0,0-5.084,1.336A5.651,5.651,0,0,0,164,22.626c.136,3.688,3.429,6.289,6.952,6.523a5.889,5.889,0,0,0,4.621-1.523,3.6,3.6,0,0,0,.519-4.221c-1.522-2.9-5.539-4.658-8.707-4.619a4.038,4.038,0,0,0-3.632,1.751c-.943,1.647-.161,3.551.819,4.982C165.586,27,167,28.734,168.778,29.3a4.952,4.952,0,0,0,4.271-.806c3-2.1,3.082-6.014,1.007-8.812-2.521-3.4-6.9-4.135-10.852-3.369-4.569.886-8.784,3.345-12.833,5.53-3.364,1.815-6.711,3.677-10.216,5.21A40.96,40.96,0,0,1,128.879,30.3a40.4,40.4,0,0,1-13.738-.811,38.8,38.8,0,0,1-11.579-4.357A17.253,17.253,0,0,1,97.4,19.452c-.94-1.592-1.856-4.955.511-5.847,2.426-.913,4.076,1.633,5.057,3.41.05.091.183.184.252.058a7.314,7.314,0,0,1,2.677-3.215c1.126-.585,2.805-.516,3.416.762,1.1,2.308-.693,4.946-2.051,6.7A21.151,21.151,0,0,1,96.518,28.4a32.649,32.649,0,0,1-14.219.983,54.384,54.384,0,0,1-15.376-5.138c-2.7-1.319-5.257-2.891-7.926-4.27a76.232,76.232,0,0,0-7.68-3.469c-4.559-1.746-9.523-3.05-14.449-2.613-4.522.4-9.349,2.676-11.138,7.1-1.632,4.034-.559,9.483,2.987,12.182a9.763,9.763,0,0,0,12.193-.762c3.577-3.432,2.891-8.942-.254-12.4-1.651-1.815-3.864-3.285-6.4-3.174a8.636,8.636,0,0,0-5.584,2.294,9.083,9.083,0,0,0-1.125,11.188,8.238,8.238,0,0,0,12.467,1.346,6.587,6.587,0,0,0,1.795-6.313,8.347,8.347,0,0,0-3.071-5.7,7.154,7.154,0,0,0-10.8,3.228,7.532,7.532,0,0,0,.332,6.537,7.6,7.6,0,0,0,6.012,3.163,5.783,5.783,0,0,0,5.488-2.494,7.047,7.047,0,0,0,.363-6.072,6.768,6.768,0,0,0-4.776-4.353,5.8,5.8,0,0,0-5.918,2.629,5.9,5.9,0,0,0-.329,5.917c1.05,1.883,2.968,2.67,4.856,3.486,1.048.453,2.265.953,2.762,2.059a2.792,2.792,0,0,1-1.328,3.586c-.892.551-3.131,1.71-1.95,3.069.52.6,1.436.735,2.1,1.114a1.412,1.412,0,0,1,.726,1.813A1.51,1.51,0,0,1,34.9,44.341c-.111,0-.076.255.042.251",
    transform: "translate(7.021 3.677)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276107",
    "data-name": "Path 276107",
    d: "M146.721,24.731a2.873,2.873,0,0,0,.931,1.628,3.315,3.315,0,0,0,1.695.7c1.427.2,3.258-.1,4.079-1.409a5.382,5.382,0,0,0,.669-2.5,8.6,8.6,0,0,0-.222-2.545,8.5,8.5,0,0,0-2.333-4.145c-1.831-1.76-4.8-3.1-7.339-2.23a4.681,4.681,0,0,0-2.881,3.014,3.586,3.586,0,0,0-.058,2.281,4.73,4.73,0,0,0,1.112,1.735,6.69,6.69,0,0,0,3.8,1.959,3.306,3.306,0,0,0,3.715-1.965,5.842,5.842,0,0,0-1.033-4.721,7.6,7.6,0,0,0-9.013-2.953,7.756,7.756,0,0,0-3.645,2.853,4.35,4.35,0,0,0-.529,4.279,4.291,4.291,0,0,0,3.846,2.352,4.859,4.859,0,0,0,4.235-2.251,2.723,2.723,0,0,0-1.336-3.751,4.072,4.072,0,0,0-4.482.974,4.371,4.371,0,0,0-1.263,3.873,4.039,4.039,0,0,0,1.038,1.951c.163.174.529.028.332-.183a3.621,3.621,0,0,1-.78-3.773,4.26,4.26,0,0,1,2.927-2.681,3,3,0,0,1,2.262.26,2.474,2.474,0,0,1,1.193,1.679c.255,1.576-1.286,2.816-2.616,3.264a4.1,4.1,0,0,1-4.25-.831,3.57,3.57,0,0,1-.735-3.888,6.669,6.669,0,0,1,2.75-3.133,7.092,7.092,0,0,1,10.723,4.591,3.548,3.548,0,0,1-.214,2.325,2.686,2.686,0,0,1-1.769,1.29,4.914,4.914,0,0,1-3.674-.812,4.674,4.674,0,0,1-2.275-2.923,4.3,4.3,0,0,1,1.642-3.806c1.993-1.573,4.805-.829,6.757.421a8.331,8.331,0,0,1,3.784,7.222,5.865,5.865,0,0,1-.452,2.266,2.713,2.713,0,0,1-1.828,1.472,4.427,4.427,0,0,1-3.671-.391,2.888,2.888,0,0,1-1-1.541c-.027-.091-.105-.029-.088.044",
    transform: "translate(38.026 3.683)",
    fill: "#363636"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5Mental);
export default __webpack_public_path__ + "static/media/5_Mental.65cd52c9953b6da674d8927f8e58c5bc.svg";
export { ForwardRef as ReactComponent };